/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./freight.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSelector } from "react-redux";
import {
  useParams,
  useNavigate,
  Navigate,
  Link,
  useLocation,
} from "react-router-dom";
import IntlCurrencyInput from "react-intl-currency-input";
import InputMask from "react-input-mask";
import driverService from "../../service/driver.service";
import freightService from "../../service/freight.service";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Stack,
  TextField,
  Chip,
} from "@mui/material";
import "@trendmicro/react-datepicker/dist/react-datepicker.css";
import firebase, { storage } from "../../config/firebase";
import ImageZoom from "../../components/imageZoom";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import ShipperDialog from "../../components/popup-shipper/insert-shipper";
import LoopIcon from "@mui/icons-material/Loop";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TextArea from "antd/es/input/TextArea";
import BackButton from "../../components/backButton/BackButton";
import paymentService from "../../service/payment.service";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import notification from "../../service/sendMessage";
import { Spin } from "antd";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InventoryIcon from "@mui/icons-material/Inventory";
import AlertDialogFreight from "./components/AlertDialogFreight";
import AddIcon from "@mui/icons-material/Add";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import FireTruckOutlinedIcon from "@mui/icons-material/FireTruckOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import GalleryDialog from "./components/GalleryDialog";
import ModernStepper from "./components/ProgressSteps";
import userService from "../../service/user.service";
import ModernAlertDialog from "./components/ModernAlertDialog";
import {
  DragDropContext,
  Droppable,
  Draggable,
} from "@hello-pangea/dnd";
import Utils from "../../util/utils";
import { getDistance } from "geolib";
import ProductTable from "../../components/Product-Table-Freight/ProductTable";
import GroupsIcon from "@mui/icons-material/Groups";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

require("firebase/auth");

function Freight() {
  let navigate = useNavigate();

  const location = useLocation();

  const { id } = useParams();

  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);

  // const [status, setStatus] = useState("Pendrente de contatação");
  const [status, setStatus] = useState("Pendente de validação");
  const [code, setCode] = useState("00");

  const [numberSerial, setNumberSerial] = useState(Date.now());
  const [verifyPayment, setVerifyPayment] = useState(false);

  // Estado para armazenar dados do orçamento quando vier de um orçamento aprovado
  const [budgetDataSaved, setBudgetDataSaved] = useState(null);

  // Client Payment
  const [payingCustomer, setPayingCustomer] = useState("");
  const [cnpjPayingCustomer, setCnpjPayingCustomer] = useState("");

  //Veiculo
  const [occupation, setOccupation] = useState();
  const [freeOfCharge, setFreeOfCharge] = useState();

  var nameUser = useSelector((state) => state?.user?.name);

  //Frete

  const { idFreight } = useParams();
  const [groups, setGroups] = useState([]);
  const [shipperGroups, setShipperGroups] = useState([]);
  const [formFieldsOriginal, setFormFieldsOriginal] = useState("");
  const [freightOrigin, setFreightOrigin] = useState("");
  const [product, setProduct] = useState([]);
  const [operational, setOperational] = useState("");
  const [seller, setSeller] = useState(nameUser);
  const [sellerId, setSellerId] = useState("");
  const [valueNF, setValueNF] = useState("");
  const [valueFreightage, setValueFreightage] = useState("");
  const [totalAmountRoute, setTotalAmountRoute] = useState("");
  const [weightCargo, setWeightCargo] = useState(0);
  const [phoneRespContractFreigtage, setPhoneRespContractFreigtage] =
    useState("");
  const [valueDriverInitial, setValueDriverInitial] = useState(0);
  const [valueNegotiated, setValueNegotiated] = useState(0);
  const [paymentCondition, setPaymentCondition] = useState("");
  const [valueDriverFinal, setValueDriverFinal] = useState(0);
  const [uidDriver, setUidDriver] = useState("");
  const [observation, setObservation] = useState();
  const [internalObservations, setInternalObservations] = useState();
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [driversInFila, setDriversInFila] = useState([]);
  const [referenc, setReferenc] = useState("");
  const [driverChose, setDriverChose] = useState("");

  const [msgTipo, setMsgTipo] = useState();
  const [msg, setMsg] = useState();
  const [title, setTitle] = useState();

  const [carregando, setCarregando] = useState(0);
  const usuarioEmail = useSelector((state) => state.usuarioEmail);

  const users = useSelector((state) => state.user);
  const shippers = useSelector((state) => state.shipper);

  const [origem, setOrigem] = useState("");
  const [openOrigem, setOpenOrigem] = useState(false);
  const [openShipper, setOpenShipper] = useState(false);

  const [view, setOnlyView] = useState(location.state?.viewOnly || false);

  const [nameButtonImport, setNameButtonImport] = useState("Importar Canhoto");
  const [coordinates, setCoordinates] = useState(false);

  const [currentOperationType, setCurrentOperationType] = useState("");

  const [uidShipperPayment, setUidShipperPayment] = useState("");

  const [sellersList, setSellersList] = useState([]);

  const [load, setLoad] = useState(false);
  const [loadVerify, setLoadVerify] = useState(false);

  const selectedShipperId = uidShipperPayment?.uid || null;
  const [shipperGroupOrder, setShipperGroupOrder] = useState([]); // groupOrder atual do embarcador (IDs + active + datas)
  const saveGroupVisualizerOnShipper = async (shipperIdToSave, orderedGroups) => {
    if (!shipperIdToSave) return;

    const groupVisualizer = orderedGroups.map((g) => ({ uid: g.idGroup }));

    await db.collection("shipper").doc(shipperIdToSave).update({
      groupVisualizer,
    });
  };


  const handleDragEndGroups = async (result) => {
    if (!result.destination) return;
    if (view) return;

    const items = Array.from(shipperGroups || []);
    if (items.length === 0) return;

    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);

    setShipperGroups(items);

    // monta e salva o groupOrder
    const groupOrder = buildGroupOrderToSave(items);

    try {
      // ✅ salva no SHIPPER correto (o selecionado)
      if (selectedShipperId) {
        await db.collection("shipper").doc(selectedShipperId).update({
          groupOrder,
          groupVisualizer: items.map((g) => ({ uid: g.idGroup })),
        });
      }

      // ✅ salva no FRETE: só se existir idFreight
      if (idFreight) {
        await db.collection("freight").doc(idFreight).update({
          groupOrder,
        });
      }

      // mantém em memória
      setShipperGroupOrder(groupOrder);
    } catch (e) {
      console.error("Erro ao salvar groupOrder:", e);
    }
  };

  // id do embarcador (você já usa users.uidShipper no seu save)
  const shipperId = users?.uidShipper; // ajuste se seu id do embarcador for outro

  // pega nome do grupo de forma segura
  const getGroupName = (g) => g?.name || g?.nome || g?.descricao || "";

  // monta o JSON para salvar no embarcador (regra do active aplicada)
  const buildGroupOrderToSave = (orderedGroups) => {
    const now = new Date().toISOString();

    return orderedGroups.map((g, index) => ({
      active: index === 0,                 // 🔥 regra
      idGroup: g.idGroup,
      date_includ: now,
      date_updated: now,
      name: getGroupName(g),
    }));
  };

  // salva no cadastro do embarcador
  const saveGroupOrderOnShipper = async (orderedGroups) => {
    if (!shipperId) return;

    const groupOrder = buildGroupOrderToSave(orderedGroups);

    await db.collection("shipper").doc(shipperId).update({
      groupOrder,
    });

    setShipperGroupOrder(groupOrder); // mantém em memória também
  };



  /* ====> Codigo feito por Lucas */

  const formatName = (name) => {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => {
        // if (['da', 'de', 'do', 'dos', 'das'].includes(word)) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  /**
   * Função que atualiza o nome do botão de importação de acordo com o tipo de operação.
   * Se o tipo for "carga", o nome do botão é "Importar Canhoto", caso contrário, o nome é "Importar imagems".
   * @param {string} index - tipo de operação.
   */
  function handleNameButtonImport(index) {
    if (index === "carga") {
      setNameButtonImport("Importar Canhoto");

      return;
    } else {
      setNameButtonImport("Importar imagens");
    }
  }

  /**
   * @author @Answercode2023
   * @param {*} event
   * @param {*} index
   * O código então verifica se o nome é "carga" ou "descarga"
   * e atualiza o array operation de acordo com o estado do checkbox.
   * Se a propriedade checked for verdadeira, ele define a propriedade operation como um array contendo o valor name.
   * Se for falsa, ele define operation como um array vazio.
   */
  const handleCheckBoxChange = (event, index) => {
    const { name, checked } = event.target;

    if (name === "carga" || name === "descarga") {
      setFormFields((prev) => {
        const data = [...prev];
        // Garante que sempre exista o array operation
        if (!Array.isArray(data[index].operation)) {
          data[index].operation = [];
        }

        if (checked) {
          data[index].operation = [name];
        } else {
          data[index].operation = [];
        }
        return data;
      });
    }
  };

  const handleProductsChange = (newProducts) => {
    setProduct(newProducts);

    const total = newProducts?.reduce(
      (sum, prod) => sum + (prod.total || 0),
      0
    ) || 0;

    if (loadVerify) {
      setValueFreightage(total);
      return;
    }

    if (!load) {
      setValueFreightage(total);
      setLoad(true);
      return;
    }

    setValueFreightage(freightOrigin?.freight?.valueFreightage);
    setLoadVerify(true);
  };

  useEffect(() => {
    /**
     * Atualiza os campos operation e phoneRespContractFreight com base nos dados do motorista
     *
     * @returns {void}
     */
    const setOperationalAndPhoneFields = () => {
      if (driverChose !== "") {
        setOperational(users.name);
        setPhoneRespContractFreigtage(users.phoneNumber);
      }
    };

    setOperationalAndPhoneFields();
  }, [driverChose]);

  /**
   * Carrega a lista de vendedores associados ao Fortio.
   * @throws {Error} - Se houver um erro ao carregar a lista de vendedores
   */
  async function loadingSellers() {
    try {
      const list = await userService.usersAssociatedWithFortio();

      setSellersList(list);
    } catch (error) {
      console.error("Erro ao carregar vendedores:", error);
    }
  }

  useEffect(() => {
    loadingSellers();
  }, []);

  useEffect(() => {
    if (sellerId || !seller || !sellersList?.length) return;
    const match = sellersList.find(
      (s) => String(s?.name || "").trim() === String(seller).trim(),
    );
    if (match?.id) {
      setSellerId(match.id);
    }
  }, [seller, sellerId, sellersList]);

  {
    /* ====> Codigo acima feito por Lucas */
  }

  const db = firebase.firestore();

  const defaultBodyworkOptions = [
    { name: "BA\u00da", selected: false },
    { name: "BA\u00da FRIGOR\u00cdFICO", selected: false },
    { name: "BA\u00da REFRIGERADO", selected: false },
    { name: "SIDER", selected: false },
    { name: "CA\u00c7AMBA", selected: false },
    { name: "GRADE BAIXA", selected: false },
    { name: "GRANELEIRO", selected: false },
    { name: "PLATAFORMA", selected: false },
    { name: "PRANCHA", selected: false },
    { name: "APENAS CAVALO", selected: false },
    { name: "BUG PORTA CONT\u00caINER", selected: false },
    { name: "CAVAQUEIRA", selected: false },
    { name: "CEGONHEIRO", selected: false },
    { name: "GAIOLA", selected: false },
    { name: "HOPPER", selected: false },
    { name: "MUNCK", selected: false },
    { name: "SILO", selected: false },
    { name: "TANQUE", selected: false },
  ];

  const legacyBodyworkNameMap = {
    "BA\u00da FRIGORIFICO": "BA\u00da FRIGOR\u00cdFICO",
    "BUG PORTA CONTAINER": "BUG PORTA CONT\u00caINER",
    SILLO: "SILO",
  };

  const normalizeBodyworkName = (name = "") =>
    legacyBodyworkNameMap[name] || name;

  const normalizeTypeBodyworkList = (list) => {
    const canonicalNames = new Set(
      defaultBodyworkOptions.map((option) => option.name)
    );

    if (!list?.dados?.length) {
      return { dados: [...defaultBodyworkOptions] };
    }

    const selectedMap = new Map();

    list.dados.forEach((item) => {
      const normalizedName = normalizeBodyworkName(item?.name);
      if (canonicalNames.has(normalizedName)) {
        selectedMap.set(
          normalizedName,
          Boolean(selectedMap.get(normalizedName)) || Boolean(item?.selected)
        );
      }
    });

    return {
      ...list,
      dados: defaultBodyworkOptions.map((option) => ({
        ...option,
        selected: selectedMap.get(option.name) || false,
      })),
    };
  };

  const [typeBodyworkList, setTypeBodyworkList] = useState({
    dados: defaultBodyworkOptions,
  });

  const CanhotoViewer = ({ source }) => {
    // Esta função faz a verificação para exibir imagem ou PDF, na parte de canhoto do frete.
    // Função para verificar se o arquivo é um PDF
    const isPDF = (file) => {
      const fileName = file?.split("?")[0]; // Remove os parâmetros da URL
      return fileName?.toLowerCase().endsWith(".pdf");
    };

    return (
      <>
        {isPDF(source) ? (
          <>
            <div style={{ height: "70%", width: "100%" }}>
              <a href={source} target="_blank" rel="noopener noreferrer">
                <Button variant="outlined" color="primary">
                  Abrir PDF
                </Button>
              </a>
            </div>
          </>
        ) : (
          <>
            <ImageZoom
              title=""
              name="canhoto"
              source={source}
              height="100"
              width="100"
            />
          </>
        )}
      </>
    );
  };

  const geraNumeroColeta = () => {
    const digitosUnicos = new Set();

    while (digitosUnicos.size < 7) {
      const digito = Math.floor(Math.random() * 10);
      digitosUnicos.add(digito);
    }

    const numero = Array.from(digitosUnicos).join("");
    return numero;
  };

  {
    /**formFields representa um ponto de parada*/
  }
  const [formFields, setFormFields] = useState([
    {
      id: "",
      stop_order: 1,
      name: "",
      cpf_cnpj: "",
      operation: [],
      responsible_phone: "",
      responsible_name: "",
      number_collect: geraNumeroColeta(),
      date_operation: "",
      time_operation: "",
      type: "",
      descricao: "",
      canhoto: "",
      // attachments: [],
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      uf: "",
      latitude: "",
      longitude: "",
      manualCoordinatesEnabled: false,
      verify: false,
      observation: "",
      concluded: false,
      typeCarga: false,
      typeDescarga: false,
      checkItemLocation: false,
    },
  ]);

  const [isFormValid, setIsFormValid] = useState(false);

  /**
   * Valida os campos principais do formulário de pontos de parada.
   * Valida se todos os campos obrigatórios de cada ponto de parada
   * foram preenchidos.
   * @returns {boolean} True se o formulário estiver válido, false caso contrário.
   */
  const validateForm = () => {
    // --- Validação dos Campos Principais ---
    if (!cnpjPayingCustomer || !payingCustomer) return false;
    if (!valueDriverInitial) return false;
    if (!valueDriverFinal) return false;
    if (!occupation) return false;
    if (!freeOfCharge) return false;
    // if (!product) return false; // Se voltar a usar produto
    if (!seller) return false;
    // if (!operational) return false;
    if (!valueNF) return false;
    if (!weightCargo) return false;
    if (!valueFreightage) return false;

    // Validação Condicional (se houver motorista)
    if (uidDriver && (!valueNegotiated || !paymentCondition)) {
      return false;
    }

    if (!formFields || formFields.length === 0) {
      return false; // Precisa ter pelo menos um ponto de parada
    }

    for (const stop of formFields) {
      if (
        !stop.name ||
        !stop.cpf_cnpj ||
        stop.operation.length === 0 ||
        // !stop.responsible_name ||
        // !stop.responsible_phone ||
        !stop.date_operation ||
        !stop.time_operation ||
        !stop.cep ||
        !stop.number ||
        !stop.logradouro ||
        !stop.city ||
        !stop.uf
      ) {
        return false;
      }

      if (stop.operation.includes("carga")) {
        if (!stop.type || !stop.descricao) {
          console.log(
            "Validação falhou: Tipo ou Descrição obrigatórios para Carga no ponto:",
            stop
          );
          return false;
        }
      }
    }

    return true;
  };

  useEffect(() => {
    const isValid = validateForm();
    setIsFormValid(isValid);
  }, [
    cnpjPayingCustomer,
    payingCustomer,
    valueDriverInitial,
    valueDriverFinal,
    occupation,
    freeOfCharge,
    // product, // Se voltar a usar
    seller,
    operational,
    valueNF,
    weightCargo,
    valueFreightage,
    uidDriver,
    valueNegotiated,
    paymentCondition,
    formFields,
    coordinates,
  ]);

  const addFields = () => {
    let object = {
      id: "",
      stop_order: formFields.length + 1,
      name: "",
      cpf_cnpj: "",
      operation: [],
      responsible_phone: "",
      responsible_name: "",
      number_collect: geraNumeroColeta(),
      date_operation: "",
      time_operation: "",
      type: "",
      descricao: "",
      canhoto: "",
      // attachments: [],
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      latitude: "",
      longitude: "",
      manualCoordinatesEnabled: false,
      verify: false,
      observation: "",
      concluded: false,
      typeCarga: "",
      typeDescarga: "",
      checkItemLocation: false,
    };
    setFormFields([...formFields, object]);
  };

  const [tipoVeiculo, setTipoVeiculo] = useState({
    dados: [
      { name: "FIORINO", selected: false },
      { name: "3/4", selected: false },
      { name: "TOCO", selected: false },
      { name: "VUC", selected: false },
      { name: "TRUCK", selected: false },
      { name: "BI-TRUCK", selected: false },
      { name: "CARRETA S", selected: false },
      { name: "CARRETA LS", selected: false },
      { name: "RODOTREM", selected: false },
      { name: "VANDERLEIA", selected: false },
    ],
  });

  // const [formFieldsOriginal, setFormFieldsOriginal] = useState("");
  // const [freightOrigin, setFreightOrigin] = useState("");

  const loadingPoints = (isCopy) => {
    var listResult = [];

    db.collection("freight")
      .doc(id)
      .collection("stopping_points")
      .get()
      .then((result) => {
        result.docs.forEach((doc) => {
          if (isCopy === true) {
            listResult.push({
              id: doc.id,
              stop_order: doc.data().stop_order,
              name: doc.data().name,
              cpf_cnpj: doc.data().cpf_cnpj,
              operation: doc.data().operation,
              responsible_phone: doc.data().responsible_phone,
              responsible_name: doc.data().responsible_name,
              number_collect: doc.data().number_collect,
              date_operation: (doc.data().date_operation = ""),
              time_operation: (doc.data().time_operation = ""),
              canhoto: (doc.data().canhoto = null),
              // attachments: doc.data().attachments || [],
              cep: doc.data().cep,
              number: doc.data().number,
              logradouro: doc.data().logradouro,
              city: doc.data().city,
              uf: doc.data().uf,
              latitude: doc.data().latitude,
              longitude: doc.data().longitude,
              manualCoordinatesEnabled:
                doc.data().manualCoordinatesEnabled || false,
              verify: (doc.data().verify = false),
              observation: (doc.data().observation = ""),
              concluded: (doc.data().concluded = false),
              type: "",
              descricao: "",
            });
            setFormFieldsOriginal(listResult);
          } else {
            listResult.push({
              id: doc.id,
              stop_order: doc.data().stop_order,
              name: doc.data().name,
              cpf_cnpj: doc.data().cpf_cnpj,
              operation: doc.data().operation,
              responsible_phone: doc.data().responsible_phone,
              responsible_name: doc.data().responsible_name,
              number_collect: doc.data().number_collect,
              date_operation: doc.data().date_operation,
              time_operation: doc.data().time_operation,
              canhoto: doc.data().canhoto,
              // attachments: doc.data().attachments || [],
              cep: doc.data().cep,
              number: doc.data().number,
              logradouro: doc.data().logradouro,
              city: doc.data().city,
              uf: doc.data().uf,
              latitude: doc.data().latitude,
              longitude: doc.data().longitude,
              verify: doc.data().verify,
              observation: doc.data().observation,

              concluded: doc.data().concluded,
              type: doc.data().type,
              descricao: doc.data().descricao,
            });
            setFormFieldsOriginal(listResult);
          }
        });

        handleNameButtonImport(listResult[0].operation[0]);
        setFormFieldsOriginal(listResult);
        setFormFields(listResult);
        setCarregando(0);
      })
      .catch((error) => {
        setCarregando(0);
        console.error(error);
      });

    return listResult;
  };

  var listClientIn = [];

  const [listClient, setListClient] = useState([]);
  const [listECClient, setListECClient] = useState([]);

  // Conecta o embarcador selecionado ao card de grupos do frete.
  // Prioriza `groupOrder` quando existir; caso contrário, reconstrói via `groupVisualizer`.
  const syncGroupsFromShipper = async (shipperData) => {
    if (!shipperData) {
      setShipperGroups([]);
      setShipperGroupOrder([]);
      return;
    }

    const groupOrder = Array.isArray(shipperData.groupOrder)
      ? shipperData.groupOrder.filter((group) => group?.idGroup)
      : [];

    if (groupOrder.length > 0) {
      setShipperGroups(groupOrder);
      setShipperGroupOrder(groupOrder);
      return;
    }

    const groupVisualizerIds = Array.isArray(shipperData.groupVisualizer)
      ? shipperData.groupVisualizer.map((group) => group?.uid).filter(Boolean)
      : [];

    if (groupVisualizerIds.length === 0) {
      setShipperGroups([]);
      setShipperGroupOrder([]);
      return;
    }

    try {
      const groupDocs = await Promise.all(
        groupVisualizerIds.map(async (groupId) => {
          const groupDoc = await db.collection("tb_group").doc(groupId).get();

          if (!groupDoc.exists) {
            return null;
          }

          return {
            idGroup: groupDoc.id,
            name: groupDoc.data()?.name || "",
            ...groupDoc.data(),
          };
        })
      );

      const orderedGroups = groupDocs.filter(Boolean);

      setShipperGroups(orderedGroups);
      setShipperGroupOrder(buildGroupOrderToSave(orderedGroups));
    } catch (error) {
      console.error("Erro ao sincronizar grupos do embarcador:", error);
      setShipperGroups([]);
      setShipperGroupOrder([]);
    }
  };

  // O pagador do frete deve privilegiar o nome fantasia do embarcador.
  const getShipperDisplayName = (shipperData, fallback = "") =>
    shipperData?.dataPersonal?.nameFantasy || fallback;

  // O dropdown mostra apenas o nome fantasia no label visível.
  const getShipperOptionLabel = (option) => {
    if (typeof option === "string") return option;
    return option?.dataPersonal?.nameFantasy || "";
  };

  // Normaliza para comparar nome fantasia e razão social sem ruído.
  const normalizeShipperName = (value) =>
    String(value || "").trim().toLowerCase();

  // Oculta do autocomplete registros sem nome fantasia disponível.
  const hasUniqueFantasyName = (shipperData) => {
    const fantasyName = normalizeShipperName(
      shipperData?.dataPersonal?.nameFantasy
    );
    const socialName = normalizeShipperName(
      shipperData?.dataPersonal?.socialName
    );

    return Boolean(fantasyName) && fantasyName !== socialName;
  };

  // Filtra o pagador somente pelo nome fantasia.
  const filterShipperByFantasyName = (options, { inputValue }) => {
    const normalizedInput = normalizeShipperName(inputValue);
    const optionsWithFantasyName = options.filter(hasUniqueFantasyName);

    if (!normalizedInput) return optionsWithFantasyName;

    return optionsWithFantasyName.filter((option) =>
      normalizeShipperName(option?.dataPersonal?.nameFantasy).includes(
        normalizedInput
      )
    );
  };

  // Busca shipper por UID no frete
  async function findShipperByUID(uid) {
    if (!uid) return null;
    try {
      const doc = await db.collection("shipper").doc(uid).get();
      if (doc.exists) {
        return { id: doc.id, ...doc.data() };
      }
      return null;
    } catch (error) {
      console.error("Erro ao buscar shipper por UID:", error);
      return null;
    }
  }

  // Busca shipper por nome fantasia ou razão social no frete (fallback apenas)
  async function findShipperByNomeFantasia(nomeFantasia) {
    if (!nomeFantasia) return null;
    const normalized = String(nomeFantasia).trim();
    if (!normalized) return null;

    try {
      // Busca APENAS por nameFantasy, não por socialName
      let query = await db
        .collection("shipper")
        .where("dataPersonal.nameFantasy", "==", normalized)
        .get();

      if (!query.empty) {
        const doc = query.docs[0];
        return { id: doc.id, ...doc.data() };
      }

      return null;
    } catch (error) {
      console.error("Erro ao buscar shipper por nome fantasia:", error);
      return null;
    }
  }

  // Centraliza a aplicação do embarcador selecionado no card de pagador.
  const applyPayingCustomerFromShipper = (
    shipperData,
    { fallbackName = "", fallbackCnpj = "", fallbackUid = "" } = {}
  ) => {
    if (!shipperData) return;

    setPayingCustomer(getShipperDisplayName(shipperData, fallbackName));
    setCnpjPayingCustomer(
      shipperData?.dataPersonal?.documentNumber || fallbackCnpj || ""
    );
    setUidShipperPayment(shipperData?.id || fallbackUid || "");
    setListECShipper(shipperData);
  };

  // Corrige fretes antigos resolvendo o shipper por uid ou pelo nome salvo.
  const resolveAndApplyPaymentShipper = async (
    { name = "", cnpj = "", uid = "" } = {},
    { shouldSyncGroups = false } = {}
  ) => {
    let shipperData = null;

    if (uid) {
      shipperData = await findShipperByUID(uid);
    }

    if (!shipperData && name) {
      shipperData = await findShipperByNomeFantasia(name);
    }

    if (!shipperData) return false;

    applyPayingCustomerFromShipper(shipperData, {
      fallbackName: name,
      fallbackCnpj: cnpj,
      fallbackUid: uid,
    });

    if (shouldSyncGroups) {
      syncGroupsFromShipper(shipperData);
    }

    return true;
  };

  const handleChangeClient = (event) => {
    applyPayingCustomerFromShipper(event);
    // Atualiza os grupos sempre que o embarcador for trocado no autocomplete.
    syncGroupsFromShipper(event);
  };

  const [listShipper, setListShipper] = useState([]);
  const [listECShipper, setListECShipper] = useState("Embarcador");

  async function loadingShipper() {
    try {
      if (users?.viewALL) {
        // Se tem permissão para ver todos, busca todos os shippers
        const result = await db.collection("shipper").get();
        const shippers = [];

        result.docs.forEach((doc) => {
          shippers.push({
            id: doc.id,
            ...doc.data(),
          });
        });

        setListShipper(shippers.filter(hasUniqueFantasyName));
        setCarregando(0);
      } else {
        // Verifica se há shippers afiliados
        if (users?.uidShipperAffiliates && Array.isArray(users.uidShipperAffiliates)) {
          const affiliateUids = Array.isArray(users?.uidShipperAffiliates) ? users.uidShipperAffiliates : [];
          const primaryUid = users?.uidShipper ? [users.uidShipper] : [];
          const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

          const shippers = [];

          // Busca cada shipper pelos IDs
          for (const uid of uids) {
            try {
              const docRef = db.collection("shipper").doc(uid);
              const docSnap = await docRef.get();

              if (docSnap.exists) {
                shippers.push({
                  id: docSnap.id,
                  ...docSnap.data(),
                });
              }
            } catch (err) {
              console.error(`Erro ao buscar shipper ${uid}:`, err);
            }
          }

          setListShipper(shippers.filter(hasUniqueFantasyName));
          setCarregando(0);
        } else {
          // Busca apenas o shipper principal
          const result = await db
            .collection("shipper")
            .doc(users.uidShipper)
            .get();

          if (result.exists) {
            setListShipper([
              {
                id: result.id,
                ...result.data(),
              },
            ].filter(hasUniqueFantasyName));
          }
          setCarregando(0);
        }
      }
    } catch (error) {
      setCarregando(0);
      console.error("Erro ao buscar shippers:", error);
    }
  }

  async function loadingCustomer() {
    await db
      .collection("client")
      .get()
      .then((result) => {
        result.docs.forEach((doc) => {
          listClientIn.push({
            id: doc.id,
            ...doc.data(),
          });
        });

        setListClient(listClientIn);
        setListECClient([]);

        setCarregando(0);
      })
      .catch((error) => {
        setCarregando(0);
        console.error(error);
      });
  }

  function loadingQueue() {
    var query = "";

    if (user.viewALL) {
      query = db.collection("drivers_users");
    } else {
      if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
        const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
        const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
        const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

        if (uids.length > 1) {
          query = db.collection("drivers_users")
            .where('uidShipper', 'in', uids);
        }
        else {
          query = db.collection("drivers_users")
            .where('uidShipper', '==', user.uidShipper);
        }
      }
      else {
        query = db.collection("drivers_users")
          .where('uidShipper', '==', user.uidShipper);
      }
    }




    query.get().then((result) => {
      const listDriverInFila = [];

      result.docs.forEach(async (doc) => {
        console.log("doc", doc.data());

        const driverData = {
          id: doc.id,
          ...doc.data(),
        };

        const allDataRef = db
          .collection("drivers_users")
          .doc(doc.id)
          .collection("documents")
          .doc("allData");

        const allDataSnapshot = await allDataRef.get();


        if (allDataSnapshot.exists) {
          const extraData = allDataSnapshot.data();

          // Usa optional chaining para evitar erro quando personalData não existe
          const personal = extraData?.personalData || {};

          // Sobrescrevemos ou adicionamos os campos que o Autocomplete usa
          driverData.name = personal.fullName || driverData.name || "";
          driverData.cpf = personal.documentCpf || driverData.cpf || "";
        }

        // Verifica se a coleção myFreightList existe
        const myFreightListRef = db
          .collection("drivers_users")
          .doc(doc.id)
          .collection("myFreightsList");

        const myFreightListSnapshot = await myFreightListRef.get();

        // Adiciona uma propriedade para priorizar quem possui myFreightList
        driverData.hasMyFreightList = !myFreightListSnapshot.empty;

        listDriverInFila.push(driverData);

        // Após verificar todos os motoristas, organiza a lista
        if (listDriverInFila.length === result.docs.length) {
          const sortedList = listDriverInFila.sort((a, b) => {
            return b.hasMyFreightList - a.hasMyFreightList;
          });

          const withMyFreightList = sortedList.filter(
            (driver) => driver.hasMyFreightList
          );
          const withoutMyFreightList = sortedList.filter(
            (driver) => !driver.hasMyFreightList
          );

          const separatedList = [
            {
              name: "-----------------",
              cpf: "",
              value: "",
              id: "",
              uid: "",
            },
            ...withMyFreightList,
            {
              name: "-----------------",
              cpf: "",
              value: "",
              id: "",
              uid: "",
            },
            ...withoutMyFreightList,
          ];


          setDriversInFila(separatedList);
          setCarregando(0);
        }
      });

    });



    // db.collection("drivers_users")
    //   .where("uidShipper", "==", users.uidShipper)
    //   .get()
    //   .then((result) => {
    //     const listDriverInFila = [];

    //     result.docs.forEach(async (doc) => {
    //       const driverData = {
    //         id: doc.id,
    //         ...doc.data(),
    //       };

    //       const allDataRef = db
    //         .collection("drivers_users")
    //         .doc(doc.id)
    //         .collection("documents")
    //         .doc("allData");

    //       const allDataSnapshot = await allDataRef.get();


    //       if (allDataSnapshot.exists) {
    //         const extraData = allDataSnapshot.data();

    //         // Usa optional chaining para evitar erro quando personalData não existe
    //         const personal = extraData?.personalData || {};

    //         // Sobrescrevemos ou adicionamos os campos que o Autocomplete usa
    //         driverData.name = personal.fullName || driverData.name || "";
    //         driverData.cpf = personal.documentCpf || driverData.cpf || "";
    //       }

    //       // console.log('separatedList', driverData);


    //       // Verifica se a coleção myFreightList existe
    //       const myFreightListRef = db
    //         .collection("drivers_users")
    //         .doc(doc.id)
    //         .collection("myFreightsList");

    //       const myFreightListSnapshot = await myFreightListRef.get();

    //       // Adiciona uma propriedade para priorizar quem possui myFreightList
    //       driverData.hasMyFreightList = !myFreightListSnapshot.empty;

    //       listDriverInFila.push(driverData);

    //       // Após verificar todos os motoristas, organiza a lista
    //       if (listDriverInFila.length === result.docs.length) {
    //         const sortedList = listDriverInFila.sort((a, b) => {
    //           return b.hasMyFreightList - a.hasMyFreightList;
    //         });

    //         const withMyFreightList = sortedList.filter(
    //           (driver) => driver.hasMyFreightList
    //         );
    //         const withoutMyFreightList = sortedList.filter(
    //           (driver) => !driver.hasMyFreightList
    //         );

    //         const separatedList = [
    //           {
    //             name: "-----------------",
    //             cpf: "",
    //             value: "",
    //             id: "",
    //             uid: "",
    //           },
    //           ...withMyFreightList,
    //           {
    //             name: "-----------------",
    //             cpf: "",
    //             value: "",
    //             id: "",
    //             uid: "",
    //           },
    //           ...withoutMyFreightList,
    //         ];


    //         setDriversInFila(separatedList);
    //         setCarregando(0);
    //       }
    //     });
    //   })
    // .catch((error) => {
    //   setCarregando(0);
    //   console.error(error);
    // });
  }

  async function searchIdPayment(id) {
    try {
      const dataDadoPayment = await paymentService.getEspecifico(id);

      const verifyData = dataDadoPayment.filter(
        (item) =>
          item.status?.toLowerCase() === "pago" ||
          item.status?.toLowerCase() === "solicitar pagamento"
      );

      if (verifyData.length > 0) {
        setVerifyPayment(true);
      }
    } catch (error) {
      console.error("Erro ao buscar pagamento:", error);
    }
  }

  function loadingInit(isCopy) {
    db.collection("freight")
      .doc(id)
      .get()
      .then(async (result) => {
        var freight = result.data();

        setFreightOrigin(freight);

        var clientPayment = freight.clientPayment;
        var vehicle = freight.vehicle;
        var driver = freight.driver;
        var freightTage = freight.freight;

        if (isCopy === true) {
          // cabeçalho
          setNumberSerial(numberSerial);
          setStatus();
          setCode();
          // Frete - motorista
          setUidDriver();
          setDriverChose("");
          // Dados da Entrega
          setObservation("");
          setInternalObservations("");
        } else {
          // Se o frete veio de um orçamento, usar o numberSerial do orçamento
          if (freight.fromBudget && freight.budgetId) {
            // O numberSerial do orçamento será carregado quando buscar os dados do orçamento
            // Por enquanto, usar o do frete, será atualizado quando o orçamento for carregado
            setNumberSerial(freight.numberSerial);
          } else {
            setNumberSerial(freight.numberSerial);
          }
          setStatus(freight.status.describe);
          setCode(freight.status.code);

          setUidDriver(freight.freight.getDriverFreight?.uidDriver);

          // Dados da Entrega
          setObservation(freightTage.observation);
          setInternalObservations(freightTage.internalObservations);

          if (isCopy === false) {
            await driverService
              .getDriverAvailable(freight.freight.getDriverFreight?.uidDriver)
              .then(async (itemDriver) => {
                setDriverChose(itemDriver.data());
              })
              .catch((erro) => {
                console.error(erro);
              });
          }
        }

        // pagador (inicial a partir do cliente de pagamento do frete)
        setPayingCustomer(clientPayment.name);
        setCnpjPayingCustomer(clientPayment.cnpj);
        setUidShipperPayment(clientPayment.uid);

        // Ao abrir o frete, tenta reconstruir o pagador com base no shipper real.
        await resolveAndApplyPaymentShipper(
          {
            name: clientPayment.name,
            cnpj: clientPayment.cnpj,
            uid: freight.pagador || clientPayment.uid,
          },
          { shouldSyncGroups: true }
        );

        // Se o frete veio de um orçamento, buscar os dados do orçamento e o shipper completo
        if (freight.fromBudget && freight.budgetId) {
          // Salvar referência ao orçamento
          setBudgetDataSaved({
            budgetId: freight.budgetId,
            budgetData: null, // Será carregado abaixo
            stops: null,
          });

          // Buscar dados do orçamento
          db.collection("tb_budget")
            .doc(freight.budgetId)
            .get()
            .then(async (budgetDoc) => {
              if (budgetDoc.exists) {
                const budgetData = budgetDoc.data();
                // Atualizar budgetDataSaved com os dados completos
                setBudgetDataSaved({
                  budgetId: freight.budgetId,
                  budgetData: budgetData,
                  stops: null,
                });

                // Usar o numberSerial do orçamento se disponível
                if (budgetData.numberSerial) {
                  setNumberSerial(budgetData.numberSerial);
                }

                // Usar o clientPayment do orçamento se disponível
                if (budgetData.clientPayment) {
                  setPayingCustomer(budgetData.clientPayment.name || clientPayment.name);
                  setCnpjPayingCustomer(budgetData.clientPayment.cnpj || clientPayment.cnpj);
                  setUidShipperPayment(budgetData.clientPayment.uid || clientPayment.uid);

                  // Quando o frete veio de or?amento, reaplica o pagador pelo shipper do or?amento.
                  const appliedBudgetPaymentShipper = await resolveAndApplyPaymentShipper(
                    {
                      name: budgetData.clientPayment.name || clientPayment.name,
                      cnpj: budgetData.clientPayment.cnpj || clientPayment.cnpj,
                      uid: budgetData.clientPayment.uid || clientPayment.uid,
                    },
                    { shouldSyncGroups: true }
                  );

                  if (!appliedBudgetPaymentShipper) {
                    setListECShipper(budgetData.clientPayment.name || clientPayment.name);
                    setShipperGroups([]);
                    setShipperGroupOrder([]);
                  }
                } else {
                  // Se não tiver clientPayment no orçamento, buscar shipper pelo uid do frete
                  if (clientPayment.uid) {
                    db.collection("shipper")
                      .doc(clientPayment.uid)
                      .get()
                      .then((shipperDoc) => {
                        if (shipperDoc.exists) {
                          const shipperData = {
                            id: shipperDoc.id,
                            ...shipperDoc.data(),
                          };
                          applyPayingCustomerFromShipper(shipperData, {
                            fallbackName: clientPayment.name,
                            fallbackCnpj: clientPayment.cnpj,
                            fallbackUid: clientPayment.uid,
                          });
                          syncGroupsFromShipper(shipperData);
                        } else {
                          setListECShipper(clientPayment.name);
                          setShipperGroups([]);
                          setShipperGroupOrder([]);
                        }
                      })
                      .catch((error) => {
                        console.error("Erro ao buscar shipper:", error);
                        setListECShipper(clientPayment.name);
                        setShipperGroups([]);
                        setShipperGroupOrder([]);
                      });
                  } else {
                    setListECShipper(clientPayment.name);
                    setShipperGroups([]);
                    setShipperGroupOrder([]);
                  }
                }
              } else {
                // Se não encontrar o orçamento, usar os dados do frete e buscar shipper
                if (clientPayment.uid) {
                  db.collection("shipper")
                    .doc(clientPayment.uid)
                    .get()
                    .then((shipperDoc) => {
                      if (shipperDoc.exists) {
                        const shipperData = {
                          id: shipperDoc.id,
                          ...shipperDoc.data(),
                        };
                        applyPayingCustomerFromShipper(shipperData, {
                          fallbackName: clientPayment.name,
                          fallbackCnpj: clientPayment.cnpj,
                          fallbackUid: clientPayment.uid,
                        });
                        syncGroupsFromShipper(shipperData);
                      } else {
                        setListECShipper(clientPayment.name);
                        setShipperGroups([]);
                        setShipperGroupOrder([]);
                      }
                    })
                    .catch((error) => {
                      console.error("Erro ao buscar shipper:", error);
                      setListECShipper(clientPayment.name);
                      setShipperGroups([]);
                      setShipperGroupOrder([]);
                    });
                } else {
                  setListECShipper(clientPayment.name);
                  setShipperGroups([]);
                  setShipperGroupOrder([]);
                }
              }
            })
            .catch((error) => {
              console.error("Erro ao buscar orçamento:", error);
              // Em caso de erro, usar os dados do frete e buscar shipper
              if (clientPayment.uid) {
                db.collection("shipper")
                  .doc(clientPayment.uid)
                  .get()
                  .then((shipperDoc) => {
                    if (shipperDoc.exists) {
                      const shipperData = {
                        id: shipperDoc.id,
                        ...shipperDoc.data(),
                      };
                      applyPayingCustomerFromShipper(shipperData, {
                        fallbackName: clientPayment.name,
                        fallbackCnpj: clientPayment.cnpj,
                        fallbackUid: clientPayment.uid,
                      });
                      syncGroupsFromShipper(shipperData);
                    } else {
                      setListECShipper(clientPayment.name);
                      setShipperGroups([]);
                      setShipperGroupOrder([]);
                    }
                  })
                  .catch((err) => {
                    console.error("Erro ao buscar shipper:", err);
                    setListECShipper(clientPayment.name);
                    setShipperGroups([]);
                    setShipperGroupOrder([]);
                  });
              } else {
                setListECShipper(clientPayment.name);
                setShipperGroups([]);
                setShipperGroupOrder([]);
              }
            });
        } else {
          // Se não veio de um orçamento, buscar shipper normalmente
          if (clientPayment.uid) {
            db.collection("shipper")
              .doc(clientPayment.uid)
              .get()
              .then((shipperDoc) => {
                if (shipperDoc.exists) {
                  const shipperData = {
                    id: shipperDoc.id,
                    ...shipperDoc.data(),
                  };
                  applyPayingCustomerFromShipper(shipperData, {
                    fallbackName: clientPayment.name,
                    fallbackCnpj: clientPayment.cnpj,
                    fallbackUid: clientPayment.uid,
                  });
                  syncGroupsFromShipper(shipperData);
                } else {
                  setListECShipper(clientPayment.name);
                  setShipperGroups([]);
                  setShipperGroupOrder([]);
                }
              })
              .catch((error) => {
                console.error("Erro ao buscar shipper:", error);
                setListECShipper(clientPayment.name);
                setShipperGroups([]);
                setShipperGroupOrder([]);
              });
          } else {
            setListECShipper(clientPayment.name);
            setShipperGroups([]);
            setShipperGroupOrder([]);
          }
        }

        // veiculo
        setTipoVeiculo(vehicle.typeVehicle);
        setTypeBodyworkList(normalizeTypeBodyworkList(vehicle.typeBodywork));
        setOccupation(vehicle.occupation);
        setFreeOfCharge(vehicle.freeOfCharge);


        // Motorista
        setValueDriverInitial(driver.valueInitial);
        setValueDriverFinal(driver.valueFinal);
        setValueNegotiated(driver.valueNegotiated);
        setPaymentCondition(driver.paymentCondition);

        // Frete
        setProduct(freightTage?.newProducts?.length > 0 ? freightTage.newProducts : []);
        setSeller(freightTage.seller);
        setSellerId(freightTage.sellerId || "");
        setOperational(freightTage.operational);
        setPhoneRespContractFreigtage(freightTage.phoneRespContractFreigtage);
        setWeightCargo(freightTage.weightCargo);
        setValueNF(freightTage.valueNF);
        setValueFreightage(freightTage.valueFreightage);

        setLoad(true);

        // ???
        setTotalAmountRoute(freightTage.totalAmountRoute);

        setCarregando(0);
      })
      .catch((error) => {
        console.error(error);
        setMsgTipo("erro");
        setCarregando(0);
        setTitle(" Ops!");
        setMsg(
          "Não foi possível carregar o frete no momento, por favor tente mais tarde."
        );
        setOpen(true);
        return;
      });
  }

  const { search } = useLocation();

  const params = new URLSearchParams(search);
  var isCopy = params.get("copy") === null ? false : true;

  const [idVerify, setId] = useState(id);

  useEffect(() => {
    let isCopyTemp = isCopy === false ? false : true;

    if (isCopyTemp === false) {
      if (idVerify) {
        loadingInit(isCopyTemp);
        loadingPoints();
        searchIdPayment(idVerify);
      }
    } else {
      loadingInit(isCopyTemp);
      loadingPoints(isCopyTemp);
      setId(null);
    }

    /**
     * A chamada loadingQueue() foi comentada, por que estava sendo chamada,
     * antes de o Redux preencher o estado user e users.uidShipper, o que causava erro na consulta.
     *  A chamada foi movida para um useEffect que monitora a variável users.
     **/
    // loadingQueue();
    loadingCustomer();
    loadingShipper();
  }, [idVerify, isCopy]);

  /**
   * Monitora a variável users e chama loadingQueue() quando users.uidShipper estiver disponível.
   */
  useEffect(() => {
    if (users && users.uidShipper) {
      loadingQueue();
    }
  }, [users]);

  /**
   * Carrega dados do orçamento quando vier de um orçamento aprovado
   */
  useEffect(() => {
    if (location.state?.fromBudget && location.state?.budgetData) {
      const budgetData = location.state.budgetData;
      const stops = location.state.stops || [];

      // Salvar os dados do orçamento em um estado local ANTES de limpar o location.state
      setBudgetDataSaved({
        budgetId: location.state.budgetId,
        budgetData: budgetData,
        stops: stops,
      });

      // Preencher dados do pagador
      if (budgetData.clientPayment) {
        setPayingCustomer(budgetData.clientPayment.name || "");
        setCnpjPayingCustomer(budgetData.clientPayment.cnpj || "");
        setUidShipperPayment(budgetData.clientPayment.uid || "");

        // Fluxo de entrada vindo de or?amento aprovado.
        resolveAndApplyPaymentShipper(
          {
            name: budgetData.clientPayment.name || "",
            cnpj: budgetData.clientPayment.cnpj || "",
            uid: budgetData.clientPayment.uid || "",
          },
          { shouldSyncGroups: true }
        )
          .then((appliedBudgetPaymentShipper) => {
            if (!appliedBudgetPaymentShipper) {
              setListECShipper(budgetData.clientPayment.name || "");
              setShipperGroups([]);
              setShipperGroupOrder([]);
            }
          })
          .catch((error) => {
            console.error("Erro ao buscar shipper:", error);
            setListECShipper(budgetData.clientPayment.name || "");
            setShipperGroups([]);
            setShipperGroupOrder([]);
          });
      }
      // Preencher dados do veículo
      if (budgetData.vehicle) {
        setTipoVeiculo(budgetData.vehicle.typeVehicle || tipoVeiculo);
        setTypeBodyworkList(normalizeTypeBodyworkList(budgetData.vehicle.typeBodywork));
        setOccupation(budgetData.vehicle.occupation || "");
        setFreeOfCharge(budgetData.vehicle.freeOfCharge || "");
      }

      // Preencher dados da precificação
      if (budgetData.pricing?.products) {
        setProduct(budgetData.pricing.products || []);
        const total = budgetData.pricing.products.reduce(
          (sum, prod) => sum + (prod.total || 0),
          0
        );
        setValueFreightage(total);
      }

      // Preencher dados do resumo
      if (budgetData.summary) {
        setSeller(budgetData.summary.seller || "");
        setSellerId(budgetData.summary.sellerId || "");
        setWeightCargo(budgetData.summary.weightCargo || 0);
        setValueNF(budgetData.summary.valueNF || "");
        setValueFreightage(budgetData.summary.valueFreightage || "");
        setPaymentCondition(budgetData.summary.paymentCondition || "");
        setObservation(budgetData.summary.observation || "");
      }

      // Preencher número serial
      if (budgetData.numberSerial) {
        setNumberSerial(budgetData.numberSerial);
      }

      // Preencher pontos de parada
      if (stops.length > 0) {
        setFormFields(stops);
      }

      // Limpar o state para evitar recarregar ao navegar novamente
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  /**
   * Busca os dados do shipper baseado no ID armazenado no Redux (users.uidShipper).
   */
  useEffect(() => {
    /**
     * Busca os dados do shipper baseado no ID armazenado no Redux (users.uidShipper)
     * e atualiza o estado com os dados encontrados.
     * Se o shipper for encontrado, seta o estado com o nome da empresa e o CNPJ.
     * Caso contr rio, n o realiza nenhuma a o.
     */
    const searchForShipper = async () => {
      try {

        const fretesEncontrados = await freightService.getShipperById(
          users.uidShipper
        );
        setListECShipper(fretesEncontrados.dataPersonal.nameFantasy);
        setPayingCustomer(getShipperDisplayName(fretesEncontrados));
        setCnpjPayingCustomer(fretesEncontrados.dataPersonal.documentNumber);
        setUidShipperPayment(fretesEncontrados.id || users.uidShipper || "");
        syncGroupsFromShipper(fretesEncontrados);
      } catch (error) {
        console.error("Erro ao buscar fretes:", error);
      }
    };

    searchForShipper();
  }, [users]);



  // useEffect(() => {

  //   if (cnpjPayingCustomer) {
  //     getDataUidShipper(cnpjPayingCustomer);
  //   } else {
  //     console.log("cnpjPayingCustomer não encontrado", cnpjPayingCustomer)
  //     return;
  //   }
  // }, [payingCustomer, cnpjPayingCustomer]);

  // async function getDataUidShipper(cnpjPayingCustomer) {
  //   const uidShipper = await shipperService.getShipperUid(cnpjPayingCustomer);

  //   setUidShipperPayment(uidShipper);
  // }


  async function handleDriverSaveUidShipper(uidDriver, uidShipperFreight) {
    try {
      const driverRef = await driverService.getDriverDocumentsUID(uidDriver);

      if (!driverRef || driverRef.empty) {
        console.error("Motorista não encontrado para o UID:", uidDriver);
        return;
      }

      const driverData = driverRef.docs[0].data();

      let currentList;

      if (Array.isArray(driverData.uidShipper)) {
        currentList = driverData.uidShipper; // já é array mantém
      } else if (typeof driverData.uidShipper === "string") {
        currentList = [driverData.uidShipper]; // string vira array
      } else {
        currentList = []; // undefined/null []
      }

      if (currentList.includes(uidShipperFreight)) {
        return;
      }

      // Atualiza no serviço
      await driverService.updateDriverUidShipper(
        uidDriver,
        uidShipperFreight,
        currentList
      );

      console.log("UID do embarcador salvo com sucesso para o motorista.");
    } catch (error) {
      console.error("Erro ao salvar UID do embarcador:", error);
    }
  }

  function calcularDistancia(
    latitudeOrigem,
    longitudeOrigem,
    latitudeDestino,
    longitudeDestino
  ) {
    const origem = { latitude: latitudeOrigem, longitude: longitudeOrigem };
    const destino = { latitude: latitudeDestino, longitude: longitudeDestino };

    const distanciaMetros = getDistance(origem, destino);
    const distanciaKm = (distanciaMetros / 1000).toFixed(2);

    return distanciaKm;
  }

  async function save() {
    setMsgTipo("erro");
    setCarregando(1);

    if (!validInput()) return;

    var chosenStatus = {
      describe: "Pendente de validação",
      code: "00",
    };

    // Salva no frete o nome fantasia atualmente exibido para o pagador.
    let customerPayment = {
      name: getShipperDisplayName(listECShipper, payingCustomer || ""),
      cnpj: cnpjPayingCustomer || "",
      uid: uidShipperPayment || "",
    };


    // Se vier de um orçamento, usar os dados do orçamento diretamente para garantir que sejam salvos corretamente
    // Usar budgetDataSaved se disponível (dados salvos antes do location.state ser limpo)
    const budgetData = budgetDataSaved?.budgetData || location.state?.budgetData;
    // let customerPayment;
    if (budgetDataSaved || (location.state?.fromBudget && budgetData?.clientPayment)) {
      // Usar diretamente os dados do orçamento, sem fallback para os estados
      customerPayment = {
        name: getShipperDisplayName(
          listECShipper,
          budgetData.clientPayment.name || payingCustomer || ""
        ),
        cnpj: budgetData.clientPayment.cnpj || "",
        uid: budgetData.clientPayment.uid || "",
      };
      console.log("Salvando clientPayment do orçamento:", customerPayment);
      console.log("Dados do orçamento usados:", budgetData);
    } else {
      customerPayment = {
        name: payingCustomer,
        cnpj: cnpjPayingCustomer,
        uid: uidShipperPayment,
      };
    }

    let vehicle = {
      typeVehicle: tipoVeiculo,
      typeBodywork: typeBodyworkList,
      occupation: occupation,
      freeOfCharge: freeOfCharge,
    };

    let driverFreight = {
      uidDriver: uidDriver ? uidDriver : "",
    };

    if (uidDriver && uidShipperPayment) {
      handleDriverSaveUidShipper(uidDriver, uidShipperPayment);
    }

    let driver = {
      valueInitial: valueDriverInitial,
      valueFinal: valueDriverFinal,
      valueNegotiated: valueNegotiated,
      paymentCondition: paymentCondition,
    };

    const orderedStops = [...formFields]
      .filter((item) => item.stop_order != null)
      .sort((a, b) => a.stop_order - b.stop_order);

    const primeiraRota = orderedStops[0];
    const ultimaRota = orderedStops[orderedStops.length - 1];


    var firstDelivery = {
      name: primeiraRota.name,
      cep: primeiraRota.cep,
      address: primeiraRota.logradouro,
      city: primeiraRota.city,
      uf:
        primeiraRota.uf.length > 2
          ? Utils.searchingState(primeiraRota.uf)
          : primeiraRota.uf,
      dateColeta: primeiraRota.date_operation,
      coordinates: {
        latitude: primeiraRota.latitude,
        longitude: primeiraRota.longitude,
      },
    };

    var lastDelivery = {
      name: ultimaRota?.name,
      cep: ultimaRota?.cep,
      address: ultimaRota?.logradouro,
      city: ultimaRota?.city,
      uf:
        ultimaRota?.uf.length > 2
          ? Utils.searchingState(ultimaRota.uf)
          : ultimaRota.uf,
      dateColeta: ultimaRota.date_operation,
      coordinates: {
        latitude: ultimaRota?.latitude,
        longitude: ultimaRota?.longitude,
      },
    };

    let freight = {
      product: "",
      newProducts: product?.length > 0 ? product : [],
      seller: seller,
      sellerId: sellerId || "",
      userConfirmDriver: operational ? operational : "",
      valueNF: valueNF,
      weightCargo: weightCargo,
      valueFreightage: valueFreightage,
      totalAmountRoute: calcularDistancia(
        primeiraRota.latitude,
        primeiraRota.longitude,
        ultimaRota?.latitude,
        ultimaRota?.longitude
      ),
      observation: observation ? observation : "",
      internalObservations: internalObservations ? internalObservations : "",
      phoneRespContractFreigtage: withoutMaskPhone(phoneRespContractFreigtage),
      getDriverFreight: driverFreight,
      pagador: uidShipperPayment || "",
    };

    let shipper = {
      uid: users.uidShipper,
      name: shippers?.dataPersonal?.nameFantasy || shippers?.dataPersonal?.socialName || "",
    };

    let user = {
      uid: users.uid,
      name: users.name,
    };

    let history = {
      initialDate: new Date(),
      initialDateContrate: status === "Contratado" ? new Date() : "",
      validationPendingDate:
        status === "Pendente de validação" ? new Date() : "",
      partiallyDate: status === "Pendente de contratação" ? new Date() : "",
      atAnaliseDate: status === "Em Analise de perfil" ? new Date() : "",
      atAnaliseDateDriver:
        status === "Em Analise do motorista" ? new Date() : "",
    };

    var data = {
      clientPayment: customerPayment,
      firstDelivery: firstDelivery,
      lastDelivery: lastDelivery,
      status: chosenStatus,
      numberSerial: numberSerial,
      vehicle: vehicle,
      driver: driver,
      freight: freight,
      user: user,
      shipper: shipper,
      createUser: usuarioEmail,
      createData: new Date(),
      history: history,
    };

    // Adicionar referência ao orçamento se o frete vier de um orçamento aprovado
    // Usar budgetDataSaved se disponível (dados salvos antes do location.state ser limpo)
    const savedBudgetId = budgetDataSaved?.budgetId || location.state?.budgetId;
    const savedBudgetData = budgetDataSaved?.budgetData || location.state?.budgetData;

    if (budgetDataSaved || (location.state?.fromBudget && savedBudgetId)) {
      data.fromBudget = true;
      data.budgetId = savedBudgetId;
      // Garantir que o numberSerial do frete seja o mesmo do orçamento
      if (savedBudgetData?.numberSerial) {
        data.numberSerial = savedBudgetData.numberSerial;
      }
      data.budgetNumberSerial = savedBudgetData?.numberSerial || "";
      // Garantir que o clientPayment seja exatamente o do orçamento (sobrescreve o que foi definido anteriormente)
      if (savedBudgetData?.clientPayment) {
        data.clientPayment = {
          name: savedBudgetData.clientPayment.name || "",
          cnpj: savedBudgetData.clientPayment.cnpj || "",
          uid: savedBudgetData.clientPayment.uid || "",
        };
        console.log("Garantindo clientPayment do orçamento no data:", data.clientPayment);
        console.log("Dados completos do orçamento salvos:", savedBudgetData);
      }
    }

    if (!ultimaRota.date_operation) {
      showMessage("O data de coleta precisa ser preenchido");
      document.getElementById("datacoleta").focus();
    } else {

      // Verificar se está editando (tem id) ou criando novo
      if (id) {
        // EDITANDO - Atualizar frete existente
        console.log("[Editando frete] Atualizando frete com ID:", id);

        try {
          // Atualizar dados do frete
          await db
            .collection("freight")
            .doc(id)
            .update(data);

          // Buscar pontos de parada existentes para deletar
          const existingStopsSnapshot = await db
            .collection("freight")
            .doc(id)
            .collection("stopping_points")
            .get();

          // Deletar todos os pontos existentes
          const batch = db.batch();
          existingStopsSnapshot.docs.forEach((doc) => {
            batch.delete(doc.ref);
          });
          await batch.commit();

          // Adicionar novos pontos de parada
          formFields.forEach(async (doc) => {
            const pointDataToSave = { ...doc };
            delete pointDataToSave.id; // Remover id se existir

            await db
              .collection("freight")
              .doc(id)
              .collection("stopping_points")
              .add(pointDataToSave);
          });

          // Se veio de um orçamento, atualizar o status do orçamento para "Aprovado"
          const savedBudgetId = budgetDataSaved?.budgetId || location.state?.budgetId;
          if (budgetDataSaved || (location.state?.fromBudget && savedBudgetId)) {
            try {
              await db.collection("tb_budget").doc(savedBudgetId).update({
                status: {
                  describe: "Aprovado",
                  code: "03",
                },
              });
              console.log("Status do orçamento atualizado para Aprovado");
            } catch (error) {
              console.error("Erro ao atualizar status do orçamento:", error);
            }
          }

          setCarregando(0);
          setMsgTipo("sucesso");
          navigate("/freightlist");
        } catch (error) {
          console.error("Erro ao atualizar frete:", error);
          setMsgTipo("erro");
          setCarregando(0);
          showMessage("Erro ao atualizar frete");
        }
      } else {
        // CRIANDO NOVO - Inserir novo frete
        console.log("[Criando frete] Inserindo novo frete com dados : ");

        //Salvando dados do frete
        await db
          .collection("freight")
          .add(data)
          .then(async (item) => {
            //Salvar os pontos de paradas
            formFields.forEach(async (doc) => {
              const pointDataToSave = { ...doc };

              await db
                .collection("freight")
                .doc(item.id)
                .collection("stopping_points")
                .add(pointDataToSave);
            });

            if (uidDriver) {

              //Envia notificação para todos os motoristas que não foram escolhidos
              await sendNotificationWithoutChoose(item.id, uidDriver);


              //Adicionar o myFreightList ao motorista para que ele tenha acessso no app ao frete
              await driverService
                .getDriverAvailable(uidDriver)
                .then(async (itemDriver) => {
                  var driverUser = itemDriver.data();

                  var dataDriver = {
                    driver_name: driverUser.name,
                    driver_user: driverUser.uid,
                    freightInitialized: false,
                    // hired: new Date(),
                    registrationInLineTime: new Date(),
                    status: "hired",
                  };

                  //Salvando dados do motorista na fila de fretes
                  await freightService.saveDriverQueueFreight(
                    item.id,
                    driverUser.uid,
                    dataDriver
                  );
                  //Salvando dados do motorista na aba meus fretes do app
                  await driverService.saveMyFreight(
                    driverUser.uid,
                    item.id,
                    dataDriver
                  );

                  await freightService.updateStatusFreight(
                    item.id,
                    "Contratado",
                    "04"
                  );

                  //Salvar na tabela payment os dados do pagamento
                  if (driver.paymentCondition || driver.valueNegotiated) {
                    const paymentArray = driver.paymentCondition.split("/");

                    // Percorrendo o array para acessar os valores
                    paymentArray.forEach(async (value, index) => {
                      // Nome Motorista / Número Orçamento / R$ 7.000,00 / Adiantamento / Status: Bloqueado
                      var data = {
                        idFreight: item.id,
                        driver: driverFreight.uidDriver,
                        order: numberSerial,
                        value: (driver.valueNegotiated * parseInt(value)) / 100, //Retirando a porcentagem
                        type: index == 1 ? "Saldo" : "Adiantamento",
                        status: "Bloqueado",
                      };

                      //Salvando dados do pagamento
                      await paymentService.save(data);
                    });
                  }

                  console.log(
                    "[Criando frete] Enviando notificação para o motorista : " +
                    driverUser.idNotification
                  );

                  const now = new Date();
                  const day = String(now.getDate()).padStart(2, "0");
                  const month = String(now.getMonth() + 1).padStart(2, "0");
                  const year = now.getFullYear();
                  const formattedDate = `${day}/${month}/${year}`;

                  // Enviar notificação para o motorista (estilo iFood)
                  const origemUF = primeiraRota?.uf
                    ? primeiraRota.uf.length > 2
                      ? Utils.searchingState(primeiraRota.uf)
                      : primeiraRota.uf
                    : "";
                  const origem = primeiraRota
                    ? `${primeiraRota.city || ""}${origemUF ? " - " + origemUF : ""
                      }`.trim() || "Não informado"
                    : "Não informado";
                  const destinoUF = ultimaRota?.uf
                    ? ultimaRota.uf.length > 2
                      ? Utils.searchingState(ultimaRota.uf)
                      : ultimaRota.uf
                    : "";
                  const destino = ultimaRota
                    ? `${ultimaRota.city || ""}${destinoUF ? " - " + destinoUF : ""
                      }`.trim() || "Não informado"
                    : "Não informado";

                  var title = "🚚 Novo Frete Disponível!";
                  var msg =
                    `Olá! Você recebeu um novo frete! 🎉\n\n` +
                    `📦 Frete: #${numberSerial}\n` +
                    `📅 Data: ${formattedDate}\n\n` +
                    `📍 Origem: ${origem}\n` +
                    `🎯 Destino: ${destino}\n\n` +
                    `👉 Navegue até a aba "Meus Fretes" para iniciar a viagem.\n\n` +
                    `⚡ Não perca essa oportunidade!`;

                  const freightData = {
                    freightNumber: numberSerial,
                    date: formattedDate,
                    origin: origem,
                    destination: destino,
                    type: "new_freight",
                  };

                  notification.sendNotification(
                    driverUser.idNotification,
                    msg,
                    title,
                    freightData
                  );

                  // mdfeService.createPreMdfe(item.id);

                  driverService.saveMessageInMyFreight(uidDriver, title, msg);
                })
                .catch((erro) => {
                  console.error(erro);
                });

            } else {

              const origemUF = primeiraRota?.uf
                ? primeiraRota.uf.length > 2
                  ? Utils.searchingState(primeiraRota.uf)
                  : primeiraRota.uf
                : "";
              const origem = primeiraRota
                ? `${primeiraRota.city || ""}${origemUF ? " - " + origemUF : ""
                  }`.trim() || null
                : null;
              const destinoUF = ultimaRota?.uf
                ? ultimaRota.uf.length > 2
                  ? Utils.searchingState(ultimaRota.uf)
                  : ultimaRota.uf
                : "";
              const destino = ultimaRota
                ? `${ultimaRota.city || ""}${destinoUF ? " - " + destinoUF : ""
                  }`.trim() || null
                : null;
              notification.sendNotificationToAll(
                numberSerial,
                "",
                primeiraRota.date_operation,
                origem,
                destino
              );
            }
            try {
              await paymentService.prepareEmailFreight(
                data,
                "Solicitação de Envio de Frete",
                numberSerial
              ); // envio para o service de email
            } catch (error) {
              console.error("Erro ao preparar email:", error);
            }

            // Se veio de um orçamento, atualizar o status do orçamento para "Aprovado"
            const savedBudgetId = budgetDataSaved?.budgetId || location.state?.budgetId;
            if (budgetDataSaved || (location.state?.fromBudget && savedBudgetId)) {
              try {
                await db.collection("tb_budget").doc(savedBudgetId).update({
                  status: {
                    describe: "Aprovado",
                    code: "03",
                  },
                });
                console.log("Status do orçamento atualizado para Aprovado");
              } catch (error) {
                console.error("Erro ao atualizar status do orçamento:", error);
              }
            }

            setCarregando(0);
            setMsgTipo("sucesso");
            navigate("/freightlist");


          })
          .catch((error) => {
            setMsgTipo("erro");
            setCarregando(0);
            showMessage("Erro ao salvar frete");
          });
      }
    }
  }


  async function sendNotificationWithoutChoose(idFreight, idDriver) {
    console.log("Enviando notificação para todos os motoristas que não foram escolhidos")
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    const queueSnapshot = await db.collection('freight')
      .doc(idFreight)
      .collection('queue')
      .get();

    const queueData = queueSnapshot.docs.map(doc => doc.data());
    const queueDataFiltered = queueData.filter(item => item.driver_user !== idDriver);

    //Enviar notificação para todos os motoristas que não sejam o escolhido
    queueDataFiltered.forEach(async (item) => {
      const driverData = await driverService.getDriverAvailable(item.driver_user);
      const driverUser = driverData.data();

      var title = "";
      var msg = "";

      title = "🚛 Quase lá!";
      msg =
        `Olá! ${driverUser.name}! 🎉\n\n` +
        `Você se candidatou ao frete #${numberSerial}, mas ele acabou sendo confirmado com outro motorista desta vez.\n` +
        `👀 Continue de olho no app — novos fretes estão chegando e a próxima pode ser sua!\n` +
        `Obrigado por estar com a gente.`;

      const freightData = {
        freightNumber: numberSerial,
        date: formattedDate,
        type: 'new_freight'
      };

      notification.sendNotification(
        driverUser.idNotification,
        msg,
        title,
        freightData
      );

    });
  }

  async function getDataPayment(value, driver, status, index) {
    const type = index === 1 ? "Saldo" : "Adiantamento";
    var data = {
      idFreight: id,
      driver: uidDriver,
      order: numberSerial,
      value: (driver.valueNegotiated * parseInt(value)) / 100,
      type,
      status: status,
    };

    await paymentService.save(data);
  }

  // Função para verificar alterações
  async function update(isFinalize, isCopy) {
    setMsgTipo("erro");
    setCarregando(1);
    if (!validInput()) return;

    let chosenStatus = { describe: status, code: code };

    let customerPayment = {
      name: payingCustomer || "",
      cnpj: cnpjPayingCustomer || "",
      uid: uidShipperPayment || "",
    };

    let user = {
      uid: users.uid,
      name: users.name,
    };

    let shipper = {
      uid: users.uidShipper,
      name: shippers?.dataPersonal?.nameFantasy || shippers?.dataPersonal?.socialName || "",
    };

    const orderedStops = [...formFields]
      .filter((item) => item.stop_order != null)
      .sort((a, b) => a.stop_order - b.stop_order);

    const primeiraRota = orderedStops[0];
    const ultimaRota = orderedStops[orderedStops.length - 1];


    let firstDelivery = {
      name: primeiraRota?.name,
      cep: primeiraRota?.cep,
      address: primeiraRota?.logradouro,
      city: primeiraRota?.city,
      uf:
        primeiraRota?.uf.length > 2
          ? Utils.searchingState(primeiraRota.uf)
          : primeiraRota.uf,
      dateColeta: primeiraRota?.date_operation,
      coordinates: {
        latitude: primeiraRota?.latitude,
        longitude: primeiraRota?.longitude,
      },
    };

    let lastDelivery = {
      name: ultimaRota?.name,
      cep: ultimaRota?.cep,
      address: ultimaRota?.logradouro,
      city: ultimaRota?.city,
      uf:
        ultimaRota?.uf.length > 2
          ? Utils.searchingState(ultimaRota.uf)
          : ultimaRota.uf,
      dateColeta: ultimaRota?.date_operation,
      coordinates: {
        latitude: ultimaRota?.latitude,
        longitude: ultimaRota?.longitude,
      },
    };

    // Dados organizados
    let freight = {
      product: "",
      newProducts: product?.length > 0 ? product : [],
      seller,
      sellerId: sellerId || "",
      userConfirmDriver: operational ? operational : "",
      valueNF,
      weightCargo,
      valueFreightage,
      totalAmountRoute: totalAmountRoute
        ? totalAmountRoute
        : calcularDistancia(
          primeiraRota.latitude,
          primeiraRota.longitude,
          ultimaRota?.latitude,
          ultimaRota?.longitude
        ),
      observation: observation || "",
      internalObservations: internalObservations || "",
      phoneRespContractFreigtage,
      getDriverFreight: { uidDriver: uidDriver || "" },
      pagador: uidShipperPayment || "",
    };

    let vehicle = {
      typeVehicle: tipoVeiculo,
      typeBodywork: typeBodyworkList,
      occupation,
      freeOfCharge,
    };

    let driver = {
      valueInitial: valueDriverInitial,
      valueFinal: valueDriverFinal,
      valueNegotiated: valueNegotiated,
      paymentCondition: paymentCondition,
    };

    let history = {
      dateFinished: isCopy ? "" : isFinalize ? new Date() : "",
      dateUpdate: new Date(),
    };

    let data = {
      // attachments,
      clientPayment: customerPayment,
      firstDelivery: firstDelivery,
      lastDelivery: lastDelivery,
      freight,
      vehicle,
      driver,
      user,
      shipper,
      createUser: usuarioEmail,
      createData: new Date(),
      history,
      status: chosenStatus,
      groupOrder: shipperGroupOrder,
    };

    if (!ultimaRota.date_operation) {
      showMessage("O data de coleta precisa ser preenchido");
      document.getElementById("datacoleta").focus();
      return;
    }

    if (status === "Contratado" || status === "Em transito" || uidDriver) {
      if (valueNegotiated === 0 || paymentCondition === "") {
        // Validação dos campos necessários para status 'Contratado'
        showMessage(
          "O Valor Negociado e a Condição de Pagamento são obrigatórios para fretes contratados."
        );
        if (valueNegotiated === 0) {
          document.getElementById("valueNegotiated").focus();
        } else {
          document.getElementById("paymentCondition").focus();
        }
        return;
      }
    }

    // Verificar alterações nos campos críticos
    const originalFreight = {
      // product,
      seller,
      sellerId: sellerId || "",
      operational,
      valueNF,
      weightCargo,
      valueFreightage,
      totalAmountRoute: totalAmountRoute || "",
      observation: observation || "",
      internalObservations: internalObservations || "",
      phoneRespContractFreigtage,
      getDriverFreight: { uidDriver: uidDriver || "" },

    };

    // Comparar rotas originais e atuais
    const originalRoutes = JSON.stringify(formFieldsOriginal); // Salva a versão original das rotas antes da edição
    const currentRoutes = JSON.stringify(formFields);

    const fieldsChanged =
      hasFieldsChanged(originalFreight, freightOrigin.freight) ||
      JSON.stringify(vehicle) !== JSON.stringify(data.vehicle) ||
      JSON.stringify(driver) !== JSON.stringify(data.driver) ||
      originalRoutes !== currentRoutes;

    if (isFinalize) {
      if (code === "04" || code === "05" || code === "06") {
        //Status em transito ou entregue pode ser finalizado

        if (
          formFields.every(
            (field) =>
              field.canhoto === undefined ||
              field.canhoto === "" ||
              field.canhoto === null
          )
        ) {
          showMessage(
            "Atenção: É necessário preencher os conhotos de entrega antes de finalizar o frete"
          );
          return;
        }

        chosenStatus = {
          describe: "Finalizado",
          code: "07",
        };

        // Atualiza o campo 'concluded' para true
        formFields.forEach((field) => {
          field.verify = true;
          field.concluded = true;
        });

        // atualizar o status da fila dentro do motorista
        driverService.saveStatusMyFreight(uidDriver, id, "finished");
        // atualizar o status da fila dentro do frete
        freightService.saveStatusQueueFreight(id, uidDriver, "finished");
        // exluir o frete da fila do myFrete
        driverService.deleteStatusMyFreight(uidDriver, id);
      }

      if (status === "Finalizado" && !fieldsChanged) {
        chosenStatus = { describe: "Finalizado", code: "07" };
      }
    }

    if (status === "Finalizado" && fieldsChanged) {
      chosenStatus = { describe: "Em transito", code: "05" };
    }

    if (fieldsChanged) {
      if (!uidDriver) {
        // Verifica se uidDriver é vazio, nulo ou undefined
        chosenStatus = {
          code: "01",
          describe: "Pendente de contratação",
        };
      }
    }

    // Atualização no banco
    try {
      await db
        .collection("freight")
        .doc(id)
        .update({ ...data, status: chosenStatus });

      for (const doc of formFields) {
        const pointDataToUpdate = { ...doc };
        // pointDataToUpdate.canhoto = pointDataToUpdate.canhoto || [];
        if (doc.id) {
          await db
            .collection("freight")
            .doc(id)
            .collection("stopping_points")
            .doc(doc.id)
            .update(pointDataToUpdate);
        } else {
          await db
            .collection("freight")
            .doc(id)
            .collection("stopping_points")
            .add(pointDataToUpdate);
        }
      }
      //-------------------- pagamentos --------------------
      // Salvar na tabela payment os dados do pagamento
      if (paymentCondition || valueNegotiated) {
        const paymentArray = paymentCondition.split("/");

        try {
          const dadosData = await paymentService.getEspecifico(id);
          const paymentByType = dadosData.reduce((acc, payment) => {
            if (payment?.type) {
              acc[payment.type.toLowerCase()] = payment;
            }
            return acc;
          }, {});

          await paymentService.deleteAll(id);

          await Promise.all(paymentArray.map((value, index) => {
            const type = index === 1 ? "Saldo" : "Adiantamento";
            const statusPagamento = paymentByType[type.toLowerCase()]?.status || "Bloqueado";

            return getDataPayment(value, driver, statusPagamento, index);
          }));
        } catch (error) {
          console.error(error);
        }
      }
      //------------------- fim pagamentos --------------------

      //-------------------- deletar frete da fila e myFreight --------------------
      // Essa ação volta o status do frete para Pendente de Contratação, então 
      // Devemos deletar todos os motoristas da fila deste frete.

      if (!uidDriver || uidDriver === "") {

        await freightService.deleteAllFreightQueueMyFreight(id);

        await freightService.deleteDriverQueueFreight(
          id,
          freightOrigin.freight.getDriverFreight.uidDriver
        );


      } else if (
        uidDriver &&
        [
          "Pendente de contratação",
          "Em Analise de perfil",
          "Em Analise do motorista",
        ].includes(status)
      ) {


        //Envia notificação para todos os motoristas que não foram escolhidos
        await sendNotificationWithoutChoose(id, uidDriver);

        const driverData = await driverService.getDriverAvailable(uidDriver);
        const driverUser = driverData.data();
        const dataDriver = {
          driver_name: driverUser.name,
          driver_user: driverUser.uid,
          uidFreight: id,
          freightInitialized: false,
          registrationInLineTime: new Date(),
          status: "hired",
        };


        //Primeiro deletamos todos os fretes da lista de Meus fretes dos motoristas que se candidatatam a este frete
        await freightService.deleteAllFreightQueueMyFreight(id);

        //Salvo o motorista na fila do frete
        await freightService.saveDriverQueueFreight(
          id,
          driverUser.uid,
          dataDriver
        );
        //Salvo o frete na aba de meus motoristas
        await driverService.saveMyFreight(driverUser.uid, id, dataDriver);
        // Atualizo o status do frete
        await freightService.updateStatusFreight(id, "Contratado", "04");

        console.log(
          "[Criando frete] Enviando notificação para o motorista : " +
          driverUser.idNotification
        );

        // Enviar notificação para o motorista (estilo iFood)
        const now = new Date();
        const day = String(now.getDate()).padStart(2, "0");
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const year = now.getFullYear();
        const formattedDate = `${day}/${month}/${year}`;

        const origemUF = primeiraRota?.uf
          ? primeiraRota.uf.length > 2
            ? Utils.searchingState(primeiraRota.uf)
            : primeiraRota.uf
          : "";
        const origem = primeiraRota
          ? `${primeiraRota.city || ""}${origemUF ? " - " + origemUF : ""
            }`.trim() || "Não informado"
          : "Não informado";
        const destinoUF = ultimaRota?.uf
          ? ultimaRota.uf.length > 2
            ? Utils.searchingState(ultimaRota.uf)
            : ultimaRota.uf
          : "";
        const destino = ultimaRota
          ? `${ultimaRota.city || ""}${destinoUF ? " - " + destinoUF : ""
            }`.trim() || "Não informado"
          : "Não informado";

        var title = "";
        var msg = "";

        title = "🚚 Parabéns, Sua próxima viagem já está pronta! 🎉";
        msg =
          `Olá! ${driverUser.name}! 🎉\n\n` +
          `Você recebeu um novo frete! 🎉\n\n` +
          `📦 Frete: #${numberSerial}\n` +
          `📅 Data: ${formattedDate}\n\n` +
          `📍 Origem: ${origem}\n` +
          `🎯 Destino: ${destino}\n\n` +
          `👉 Navegue até a aba "Meus Fretes" para iniciar a viagem.\n\n` +
          `⚡ Não perca essa oportunidade!`;

        const freightData = {
          freightNumber: numberSerial,
          date: formattedDate,
          origin: origem,
          destination: destino,
          type: "new_freight",
        };

        notification.sendNotification(
          driverUser.idNotification,
          msg,
          title,
          freightData
        );

        driverService.saveMessageInMyFreight(uidDriver, title, msg);
      } else if (isFinalize) {
        const driverData = await driverService.getDriverAvailable(uidDriver);
        const driverUser = driverData.data();

        // Enviar notificação para o motorista (estilo iFood)
        const now = new Date();
        const day = String(now.getDate()).padStart(2, "0");
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const year = now.getFullYear();
        const formattedDate = `${day}/${month}/${year}`;

        const origemUF = primeiraRota?.uf
          ? primeiraRota.uf.length > 2
            ? Utils.searchingState(primeiraRota.uf)
            : primeiraRota.uf
          : "";
        const origem = primeiraRota
          ? `${primeiraRota.city || ""}${origemUF ? " - " + origemUF : ""
            }`.trim() || "Não informado"
          : "Não informado";
        const destinoUF = ultimaRota?.uf
          ? ultimaRota.uf.length > 2
            ? Utils.searchingState(ultimaRota.uf)
            : ultimaRota.uf
          : "";
        const destino = ultimaRota
          ? `${ultimaRota.city || ""}${destinoUF ? " - " + destinoUF : ""
            }`.trim() || "Não informado"
          : "Não informado";

        title =
          "🚚 Obrigado por viajar conosco! Sua viagem foi finalizada com sucesso!";
        msg =
          `Olá, ${driverUser.name}! 👋🚚\n\n` +
          `Queremos te agradecer por mais uma entrega realizada com excelência! 🙌\n\n` +
          `📦 Frete: #${numberSerial}\n` +
          `📅 Data: ${formattedDate}\n\n` +
          `📍 Origem: ${origem}\n` +
          `🎯 Destino: ${destino}\n\n` +
          `🚦 Em breve, novos fretes compatíveis com seu perfil poderão aparecer no app.\n` +
          `🔔 Mantenha as notificações ativas para não perder nenhuma oportunidade!\n\n` +
          `💙 Estaremos esperando por você na próxima viagem!`;

        const freightData = {
          freightNumber: numberSerial,
          date: formattedDate,
          origin: origem,
          destination: destino,
          type: "new_freight",
        };

        notification.sendNotification(
          driverUser.idNotification,
          msg,
          title,
          freightData
        );

        driverService.saveMessageInMyFreight(uidDriver, title, msg);
      }

      // mdfeService.createPreMdfe(id);

      // Se veio de um orçamento, atualizar o status do orçamento para "Aprovado"
      if (location.state?.fromBudget && location.state?.budgetId) {
        try {
          await db.collection("tb_budget").doc(location.state.budgetId).update({
            status: {
              describe: "Aprovado",
              code: "03",
            },
          });
          console.log("Status do orçamento atualizado para Aprovado");
        } catch (error) {
          console.error("Erro ao atualizar status do orçamento:", error);
        }
      }

      setMsgTipo("sucesso");
      setCarregando(0);
      navigate("/freightlist");

      try {
        await paymentService.prepareEmailFreight(
          data,
          "Solicitação de Envio de Frete - Update",
          numberSerial
        ); // envio para o service de email
      } catch (error) {
        console.error("Erro ao preparar email:", error);
      }
    } catch (error) {
      console.error(error);
      setMsgTipo("erro");
      setCarregando(0);
    }
  }


  function hasFieldsChanged(original, updated) {
    return Object.keys(original).some(
      (key) => JSON.stringify(original[key]) !== JSON.stringify(updated[key])
    );
  }

  // Função para lidar com a seleção ou remoção de um motorista
  const handleDriver = (event, isCopy) => {
    // Chama a função addDriverVerify com o ID do motorista (ou uma string vazia, se event for nulo/indefinido)
    addDriverVerify(event ? event.id : "");

    // Verifica se o parâmetro `isCopy` é "true" ou se o parâmetro `event` é nulo/indefinido
    if (isCopy === "true" || !event) {
      setUidDriver("");
      setDriverChose("");
    } else {
      setUidDriver(event.id ? event.id : "");
      setDriverChose(event ? event : "");
    }
  };

  //------------- Validações -----------------

  function validInput() {
    if (!cnpjPayingCustomer) {
      showMessage(
        "O campo CNPJ da cessão Cliente Pagador precisa ser preenchido"
      );
      document.getElementById("cnpjPayingCustomer").focus();
      return false;
    }
    if (!payingCustomer) {
      showMessage(
        "O campo Cliente da cessão Cliente Pagador precisa ser preenchido"
      );
      document.getElementById("payingCustomer").focus();

      return false;
    }
    if (!valueDriverInitial) {
      showMessage(
        "O campo Pagamento De: e descarga da cessão Motorista precisa ser preenchido"
      );
      document.getElementById("valueDriverInitial").focus();
      return false;
    }
    if (!valueDriverFinal) {
      showMessage(
        "O campo Pagamento Até: e descarga da cessão Motorista precisa ser preenchido"
      );
      document.getElementById("valueDriverFinal").focus();
      return false;
    }
    if (!occupation) {
      showMessage("O campo Ocupação da cessão Veículo precisa ser preenchido");
      document.getElementById("occupation").focus();
      return false;
    }
    if (!freeOfCharge) {
      showMessage(
        "O campo Livre de Carga e descarga da cessão Veículo precisa ser preenchido"
      );
      document.getElementById("freeOfCharge").focus();
      return false;
    }
    if (!seller) {
      showMessage(
        "O campo Vendedor e descarga da cessão Frete precisa ser preenchido"
      );
      document.getElementById("seller").focus();
      return false;
    }
    if (!valueNF) {
      showMessage(
        "O campo Valor NF e descarga da cessão Frete precisa ser preenchido"
      );
      document.getElementById("valueNF").focus();
      return false;
    }
    if (!weightCargo) {
      showMessage(
        "O campo Peso da Carga (Kg) e descarga da cessão Frete precisa ser preenchido"
      );
      document.getElementById("weightCargo").focus();
      return false;
    }
    if (!valueFreightage) {
      showMessage(
        "O campo Valor do Frete e descarga da cessão Frete precisa ser preenchido"
      );
      document.getElementById("valueFreightage").focus();
      return false;
    }

    const hasProductValue = (value) =>
      value !== null &&
      value !== undefined &&
      !(typeof value === "string" && value.trim() === "");

    for (const prod of product || []) {
      const hasName = hasProductValue(prod?.nameProducts);
      const hasAmount = hasProductValue(prod?.amount);
      const hasPriceList = hasProductValue(prod?.priceList);
      const hasAnyProductField = hasName || hasAmount || hasPriceList;

      if (hasAnyProductField && (!hasName || !hasAmount || !hasPriceList)) {
        showMessage("Preencha todos os campos do produto: nome, quantidade e valor unitário.");
        return false;
      }
    }
    if (uidDriver && !valueNegotiated) {
      showMessage(
        "O campo Valor Negociado precisa ser preenchido"
      );
      document.getElementById("valueNegotiated").focus();
      return false;
    }
    if (uidDriver && !paymentCondition) {
      showMessage(
        "O campo Condição de Pagamento precisa ser preenchido"
      );
      document.getElementById("paymentCondition").focus();
      return false;
    }
    return true;
  }

  function showMessage(msg) {
    setMsgTipo("erro");
    setCarregando(0);
    setTitle("Campos obrigatórios!");
    setMsg(msg);
    setOpen(true);
    return;
  }

  const handleClickOpen = (id, operationType) => {
    setOpenOrigem(true);
    setReferenc(id);
    setCurrentOperationType(operationType || "");
  };

  function choseStatus(status) {
    if (status === "Pendente de validação") {
      return "00";
    }
    //Se não tiver motorista na fila é Pendente de contratação
    if (!uidDriver) {
      setStatus("Pendente de contratação");
      return "01";
    } else if (status === "Pendente de contratação") {
      return "01";
    } else if (status === "Em Analise de perfil") {
      return "02";
    } else if (status === "Em Analise do motorista") {
      return "03";
    } else if (status === "Contratado") {
      return "04";
    } else if (status === "Em transito") {
      return "05";
    } else if (status === "Entregue") {
      return "06";
    } else if (status === "Finalizado") {
      return "07";
    }
  }

  function withoutMaskPhone(input) {
    return input
      ? input
        .replace("(", "")
        .replace(")", "")
        .replace(" ", "")
        .replace("-", "")
      : "";
  }

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const weightConfig = {
    locale: "en-US",
    formats: {
      number: {
        BRL: {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const currencyConfigKm = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          //   style: "Km",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  async function buscaAPISecondario(input, form, index, data) {
    setLoading(true);

    try {
      // Tenta primeiro a API local
      const fallbackData = await fetchLocalAPI(input);
      await processarDadosAPI(fallbackData, form, index, "local");
    } catch (error) {
      console.error("Erro na API local, tentando API externa:", error);
      try {
        // Fallback para API externa
        const fallbackData = await fetchExternalAPI(input);
        await processarDadosAPI(fallbackData, form, index, "external");
      } catch (externalError) {
        console.error("Erro na API Externa 1:", externalError);
        try {
          // Segunda Tentativa API Externa
          const fallbackData = await fetchExternalAPI2(input);
          await processarDadosAPI(fallbackData, form, index, "external2");
        } catch (externalError2) {
          console.error("Erro na API Externa 2:", externalError2);
          alert(externalError2);
          return null;
        }
      }
    } finally {
      setLoading(false);
    }
  }

  // Função para buscar na API local
  async function fetchLocalAPI(cnpj) {
    const response = await fetch(`http://localhost:4000/consulta/cnpj/${cnpj}`);
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição local: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  // Função para buscar na API externa
  async function fetchExternalAPI(cnpj) {
    const response = await fetch(`https://open.cnpja.com/office/${cnpj}`);
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição externa: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  //Funcção para buscar na API Externa 2
  async function fetchExternalAPI2(cnpj) {
    const response = await fetch(
      `https://publica.cnpj.ws/cnpj/${Number(cnpj)}`
    );
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição externa: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  // Função para processar dados e obter coordenadas
  async function processarDadosAPI(fallbackData, form, index, apiType) {
    if (apiType === "local") {
      processarDadosLocal(fallbackData, form, index);
    } else if (apiType === "external") {
      processarDadosExterno(fallbackData, form, index);
    } else {
      processarDadosExterno2(fallbackData, form, index);
    }

    // Obter coordenadas
    await obterCoordenadas(form, index);

    // Salvar cliente
    await salvarCliente(form, index, fallbackData, apiType);

    setFormFields(form);
  }

  // Processar dados da API local
  function processarDadosLocal(data, form, index) {
    form[index]["name"] = data?.nome_fantasia;
    form[index]["cpf_cnpj"] = data?.cnpj;
    form[index]["cep"] = data?.endereco?.cep;
    form[index]["number"] = data?.endereco?.numero;
    form[index][
      "logradouro"
    ] = `${data?.endereco?.logradouro} - ${data?.endereco?.bairro}`;
    form[index]["city"] = data?.endereco?.municipio?.descricao;
    form[index]["uf"] = data?.endereco?.uf;
    form[index][
      "responsible_phone"
    ] = `${data?.telefones?.ddd}${data?.telefones?.numero}`;
  }

  // Processar dados da API externa
  function processarDadosExterno(data, form, index) {
    form[index]["name"] = data?.company?.name || "";
    form[index]["cpf_cnpj"] = data?.taxId || "";
    form[index]["cep"] = data?.address?.zip || "";
    form[index]["number"] = data?.address?.number || "";
    form[index]["logradouro"] = `${data?.address?.street || ""} - ${data?.address?.district || ""
      }`;
    form[index]["city"] = data?.address?.city || "";
    form[index]["uf"] = data?.address?.state || "";
    form[index]["responsible_phone"] = `${data?.phones?.area || ""}${data?.phones?.number || ""
      }`;
  }

  // Processar dados da API externa
  function processarDadosExterno2(data, form, index) {
    form[index]["name"] = data?.razao_social || "";
    form[index]["cpf_cnpj"] = data?.estabelecimento?.cnpj || "";
    form[index]["cep"] = data?.estabelecimento?.cep || "";
    form[index]["number"] = data?.estabelecimento?.numero || "";
    form[index]["logradouro"] =
      data?.estabelecimento?.logradouro + data?.estabelecimento?.complemento;
    form[index]["city"] = data?.estabelecimento?.cidade?.nome || "";
    form[index]["uf"] = data?.estabelecimento?.estado?.nome || "";
    form[index]["responsible_phone"] =
      `${data?.estabelecimento?.ddd1 || ""}${data?.estabelecimento?.telefone1 || ""
      }` ||
      `${data?.estabelecimento?.ddd2 || ""}${data?.estabelecimento?.telefone2
      }` ||
      `${data?.estabelecimento?.ddd_fax || ""}${data?.estabelecimento?.fax || ""
      }`;
  }

  // Função para obter coordenadas
  async function obterCoordenadas(form, index) {
    try {
      const cep = form[index]["cep"];
      const numero = form[index]["number"];

      if (!cep || !numero) {
        console.warn("CEP ou número não disponível para obter coordenadas");
        return;
      }

      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${cep},${numero}&key=${key}`,
        { mode: "cors" }
      );

      const data = await response.json();

      if (data.status === "OK" && data.results.length > 0) {
        const address = data.results[0];
        form[index]["latitude"] = Number(address.geometry.location.lat);
        form[index]["longitude"] = Number(address.geometry.location.lng);
      } else {
        console.warn("CEP não encontrado no Google Maps");
      }
    } catch (error) {
      console.error("Erro ao obter coordenadas:", error);
    }
  }

  // Função para salvar cliente
  async function salvarCliente(form, index, fallbackData, apiType) {
    let clientData;

    switch (apiType) {
      case "local":
        clientData = criarDadosClienteLocal(fallbackData, form, index);
        break;
      case "external":
        clientData = criarDadosClienteExterno(fallbackData, form, index);
        break;
      case "external2":
        clientData = criarDadosClienteExterno2(fallbackData, form, index);
        break;
      default:
        throw new Error(`API type desconhecido: ${apiType}`);
    }

    try {
      await driverService.saveClient(clientData);
      console.log("Cliente salvo com sucesso! API: " + apiType);
    } catch (err) {
      console.error("Erro ao salvar cliente:", err);
      throw err; // Propaga o erro para tratamento superior
    }
  }

  // Criar dados do cliente para API local
  function criarDadosClienteLocal(data, form, index) {
    return {
      name: data?.razao_social || data?.nome_fantasia,
      nameFantasy: data?.nome_fantasia,
      cnpj: data?.cnpj,
      address: {
        cep: data?.endereco?.cep,
        city: data?.endereco?.municipio?.descricao,
        complement: data?.endereco?.complemento,
        neighborhood: data?.endereco?.bairro,
        number: data?.endereco?.numero,
        state: data?.endereco?.uf,
        street: data?.endereco?.logradouro,
      },
      coordinates: {
        latitude: form[index]["latitude"],
        longitude: form[index]["longitude"],
      },
      telefone: `${data?.telefones?.ddd}${data?.telefones?.numero}`,
      typePerson: 2,
      uidShipper: user.uidShipper,
    };
  }

  // Criar dados do cliente para API externa
  function criarDadosClienteExterno(data, form, index) {
    return {
      name: data?.company?.name,
      nameFantasy: data?.company?.name,
      cnpj: data?.taxId,
      address: {
        cep: data?.address?.zip,
        city: data?.address?.city,
        complement: `${data?.address?.street} - ${data?.address?.district}`,
        neighborhood: data?.address?.district,
        number: data?.address?.number,
        state: data?.address?.state,
        street: data?.address?.street,
      },
      coordinates: {
        latitude: form[index]["latitude"],
        longitude: form[index]["longitude"],
      },
      telefone: `${data?.phones?.area}${data?.phones?.number}`,
      typePerson: 2,
      uidShipper: user.uidShipper,
    };
  }

  // Criar dados do cliente para API externa 2
  function criarDadosClienteExterno2(data, form, index) {
    return {
      name: data?.razao_social,
      nameFantasy: data?.estabelecimento?.nome_fantasia,
      cnpj: data?.estabelecimento?.cnpj,
      address: {
        cep: data?.estabelecimento?.cep,
        city: data?.estabelecimento?.cidade?.nome,
        complement:
          data?.estabelecimento?.logradouro +
          data?.estabelecimento?.complemento,
        neighborhood: data?.estabelecimento?.bairro,
        number: data?.estabelecimento?.numero,
        state: data?.estabelecimento?.estado?.nome,
        street: data?.estabelecimento?.logradouro,
      },
      coordinates: {
        latitude: form[index]["latitude"],
        longitude: form[index]["longitude"],
      },
      telefone:
        `${data?.estabelecimento?.ddd1 || ""}${data?.estabelecimento?.telefone1 || ""
        }` ||
        `${data?.estabelecimento?.ddd2 || ""}${data?.estabelecimento?.telefone2
        }` ||
        `${data?.estabelecimento?.ddd_fax || ""}${data?.estabelecimento?.fax || ""
        }`,
      typePerson: 2,
      uidShipper: user.uidShipper,
    };
  }

  //Função para consultar CNPJ
  function buscarCNPJBancoClient(input, index) {
    if (input.length < 14) {
      return;
    } else if (input.length === 14) {
      db.collection("client")
        .where("cnpj", "==", input)
        .get()
        .then((result) => {
          if (result.empty) {
            buscaAPISecondario(input, [...formFields], index); // Passamos uma cópia fresca
          } else {
            const data = result.docs[0].data();
            setFormFields((prev) => {
              const newForm = [...prev];
              newForm[index] = {
                ...newForm[index],
                name: data.name,
                cpf_cnpj: data.cnpj,
                cep: data.address.cep,
                number: data.address.number,
                logradouro: `${data.address.street} - ${data.address.neighborhood}`,
                city: data.address.city,
                uf: data.address.state,
                latitude: data.coordinates?.latitude || "",
                longitude: data.coordinates?.longitude || "",
              };
              return newForm;
            });
          }
        })
        .catch((err) => console.error(err));
    } else if (input.length === 18) {
      const inputLimpo = input.replace(/[^\d]/g, "");
      db.collection("client")
        .where("cnpj", "==", inputLimpo)
        .get()
        .then((result) => {
          var form = [...formFields];
          if (result.empty) {
            try {
              buscaAPISecondario(inputLimpo, form, index);
            } catch (err) {
              console.error(err);
            }
          } else {
            result.docs.forEach((doc) => {
              const data = doc.data();

              form[index]["name"] = data.name;
              form[index]["cpf_cnpj"] = data.cnpj;

              if (
                data.responsible &&
                data.responsible.phoneResp &&
                data.responsible.responsible
              ) {
                form[index]["responsible_phone"] = data.responsible.phoneResp;
                form[index]["responsible_name"] = data.responsible.responsible;
              } else {
                console.log(
                  "Dados de responsável ausentes ou vazios para o documento:",
                  doc.id
                );
              }

              let address;

              if (
                data.addressDelivery &&
                Object.keys(data.addressDelivery).length > 0
              ) {
                address = data.addressDelivery;
              } else {
                address = data.address;
              }

              form[index]["cep"] = address.cep;
              form[index]["number"] = address.number;
              form[index]["logradouro"] =
                address.street + " - " + address.neighborhood;
              form[index]["city"] = address.city;
              form[index]["uf"] = address.state;

              if (
                data.coordinates &&
                data.coordinates.latitude &&
                data.coordinates.longitude
              ) {
                form[index]["latitude"] = data.coordinates.latitude;
                form[index]["longitude"] = data.coordinates.longitude;
              } else {
                fetch(
                  "https://maps.googleapis.com/maps/api/geocode/json?address=" +
                  form[index]["cep"] +
                  "&key=" +
                  key,
                  { mode: "cors" }
                )
                  .then((res) => res.json())
                  .then((data2) => {
                    if (data2.hasOwnProperty("erro")) {
                      alert("Cep não existente");
                    } else {
                      var address = data2.results[0];

                      form[index]["latitude"] = Number(
                        data.location?.coordinates.latitude
                          ? data.location.coordinates.latitude
                          : address?.geometry.location.lat
                      );
                      form[index]["longitude"] = Number(
                        data.location?.coordinates.longitude
                          ? data.location.coordinates.longitude
                          : address?.geometry.location.lng
                      );
                      // alert("Dados preenchidos");
                    }
                  });
              }
            });
            setFormFields(form);
          }
        })
        .catch((err) => console.error(err));
    } else {
      alert("CNPJ invalido");
    }
  }





  /**
 * Função para consultar CEP
 * @param {string} input - CEP a ser consultado
 * @param {number} index - Índice do campo de formulário que deve ser atualizado
 * @returns {void} - Nenhum valor de retorno
 */
  function buscarCepPaying(input, index) {
    if (input.length < 8) return;

    fetch("https://brasilapi.com.br/api/cep/v1/" + input)
      .then((res) => res.json())
      .then((data) => {
        if (data.hasOwnProperty("erro") || data.name === "CepPromiseError") {
          alert("CEP não encontrado");
        } else {
          const logradouroCompleto = (data.street || "") + " - " + (data.neighborhood || "");
          const numeroAtual = String(formFields?.[index]?.number || "").trim();

          // Uso do callback (prev) para não apagar o que o usuário acabou de digitar
          setFormFields((prev) => {
            const aux = [...prev];

            aux[index] = {
              ...aux[index],
              logradouro: logradouroCompleto,
              city: data.city || "",
              uf: data.state || "",
            };
            return aux;
          });

          consultStreetByStreet(
            index,
            {
              logradouro: logradouroCompleto,
              city: data.city || "",
              uf: data.state || "",
              number: numeroAtual,
              cep: input,
            },
            false
          );
        }
      })
      .catch((err) => console.error(err));
  }


  /**
   * Função para consultar as coordenadas de um endereço
   * @param {number} index - Índice do campo de formulário que deve ser atualizado
   * @returns {void} - Nenhum valor de retorno
   * @description
   * Realiza uma chamada para a API do Google Maps para obter as coordenadas (latitude e longitude) de um endereço.
   * Se o endereço for válido, atualiza o formulário com as coordenadas e marca o campo como "checked".
   * Caso contrário, abre um alert com uma mensagem de erro.
  */
  const key = "AIzaSyAds1TwGzvflRvD8KHrbRHrnF3DvATFM1k";
  function consultStreetByStreet(index, overrides = {}, showValidationMessage = true) {
    // Pegamos os valores atuais para a busca
    const item = {
      ...(formFields?.[index] || {}),
      ...(overrides || {}),
    };
    if (!item.number || !item.logradouro || !item.city || !item.uf) {
      if (showValidationMessage) {
        setTitle("Por favor!");
        setMsg("Preencher o Endereço, Número, Cidade e Estado...");
        setOpen(true);
      }
      return;
    }

    const enderecoCompleto = `${item.logradouro} ${item.number} ${item.city} ${item.uf}`;

    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(enderecoCompleto)}&key=${key}`
    )
      .then((res) => res.json())
      .then((data2) => {
        if (data2.status === "OK") {
          const coords = data2.results[0].geometry.location;
          // Uso do callback (prev) para não apagar o que o usuário acabou de digitar
          setFormFields((prev) => {
            const newForm = [...prev];
            newForm[index] = {
              ...newForm[index],
              latitude: coords.lat,
              longitude: coords.lng,
              checkItemLocation: true,
            };
            return newForm;
          });
        }
      })
      .catch((err) => console.error(err));
  }

  const handleStopPointAddressBlur = (index, fieldName, fieldValue) => {
    const nextValue = String(fieldValue || "").trim();

    if (fieldName === "cep") {
      const cepLimpo = nextValue.replace(/\D/g, "");
      if (cepLimpo.length === 8) {
        buscarCepPaying(cepLimpo, index);
        return;
      }
    }

    consultStreetByStreet(
      index,
      {
        [fieldName]: nextValue,
      },
      false
    );
  };

  const handleClose = () => {
    setOpen(false);
    setCarregando(0);
  };

  const handleChangeInitial = (event, value, maskedValue) => {
    event.preventDefault();
    setValueDriverInitial(value);
  };

  const handleChangeFinal = (event, value, maskedValue) => {
    event.preventDefault();
    setValueDriverFinal(value);
  };

  const handleChangeValueNegotiated = (event, value, maskedValue) => {
    event.preventDefault();
    setValueNegotiated(value);
  };

  const handleChangePaymentCondition = (event, value, maskedValue) => {
    const selectedValue = event.target.value;
    setPaymentCondition(selectedValue);
  };

  const handleChangeWeightCargo = (event, value, maskedValue) => {
    event.preventDefault();
    setWeightCargo(value);
  };

  const handleChangeValueNF = (event, value, maskedValue) => {
    event.preventDefault();
    setValueNF(value);
  };

  const handleChangeValueFreightage = (event, value, maskedValue) => {
    event.preventDefault();
    setValueFreightage(value);
  };

  const handleClickDialog = () => {
    setOpenDialog(false);
  };

  const verifyUiDriver = (event) => {
    addDriverVerify(event.target.value);
    setUidDriver(event.target.value && event.target.value);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    return;
  };

  const addDriverVerify = (id) => {
    if (id !== "Selecione" && id !== "") {
      setCarregando(0);
      setTitle("Notificação para o motorista");
      setMsg(
        "Ao confirmar o salvamento deste frete, o motorista será notificado e o frete ficará disponível em seu aplicativo."
      );
      setOpen(true);
    }
  };

  const msgHaveContract = () => {
    if (!uidDriver) {
      setCarregando(0);
      setTitle("Atenção!");
      setMsg(
        "Esse status geralmente é mudado automaticamente quando o motorista aceita a carga," +
        "tem certeza que deseja mudar esse status manualmente ?"
      );
      setOpen(true);
    }
  };

  const varifyHavingDriver = () => {
    if (!uidDriver) {
      setCarregando(0);
      setTitle("Ops!");
      setMsg(
        "Para esse tipo de Status precisará selecionar um Motorista disponível da fila no campo Motorista(s)"
      );
      setOpen(true);
    }
  };

  const getStatus = (status) => {
    if (status === "Contratado") {
      return "hired";
    }
    if (status === "Entregue") {
      return "delivered";
    }
    if (status === "Em transito") {
      return "inTransit";
    } else if (
      (status === "Pendente de validação" ||
        status === "Pendente de contratação" ||
        status === "Em Analise do motorista") &&
      uidDriver
    ) {
      return "approved";
    }
  };

  //----------------------------- checked box ------------------------------------

  const handleOnChange = (e, type) => {
    const { name, checked } = e.target;
    const newTypeVehicle = [...tipoVeiculo[type]];
    const index = newTypeVehicle.findIndex((h) => h.name === name);
    if (index > -1) {
      newTypeVehicle[index] = { name, selected: checked };
    }
    setTipoVeiculo((h) => ({ ...h, [type]: newTypeVehicle }));
  };

  const renderCheckboxList = (options, type) =>
    options.map((opt) => (
      <div key={opt.name} className="checkbox-container">
        <input
          disabled={view}
          type="checkbox"
          name={opt.name}
          onChange={(e) => handleOnChange(e, type)}
          checked={opt.selected}
        />
        {opt.name}
      </div>
    ));

  const categories = {
    Leve: ["FIORINO", "3/4", "TOCO", "VUC"],
    Médio: ["TRUCK", "BI-TRUCK"],
    Pesado: ["BITREM", "CARRETA S", "CARRETA LS", "RODOTREM", "VANDERLEIA"],
  };

  const renderCategories = () => {
    return Object.keys(categories).map((category) => {
      const filteredOptions = tipoVeiculo.dados.filter((vehicle) =>
        categories[category].includes(vehicle.name)
      );

      return (
        <Card
          key={category}
          sx={{ border: "none", boxShadow: "none" }}
        >
          <div className="category-column">
            <h6 className="category-title">{category}</h6>

            {renderCheckboxList(filteredOptions, "dados")}
          </div>
        </Card>
      );
    });
  };

  const handleOnChangeBodyWork = (e, type) => {
    const { name, checked } = e.target;
    const newTypeBodyWork = [...typeBodyworkList[type]];
    const index = newTypeBodyWork.findIndex((h) => h.name === name);
    if (index > -1) {
      newTypeBodyWork[index] = { name, selected: checked };
    }
    setTypeBodyworkList((h) => ({ ...h, [type]: newTypeBodyWork }));
  };

  const renderCheckboxListBodyWork = (options, type) =>
    options.map((opt) => (
      <div key={opt.name} className="checkbox-container">
        <input
          disabled={view}
          type="checkbox"
          name={opt.name}
          onChange={(e) => handleOnChangeBodyWork(e, type)}
          checked={opt.selected}
        />
        {opt.name}
      </div>
    ));

  const categoriesBodyWork = {
    Fechada: ["BA\u00da", "BA\u00da FRIGOR\u00cdFICO", "BA\u00da REFRIGERADO", "SIDER"],
    Aberta: ["CAÇAMBA", "GRADE BAIXA", "GRANELEIRO", "PLATAFORMA", "PRANCHA"],
    Especial: [
      "BUG PORTA CONT\u00caINER",
      "CAVAQUEIRA",
      "CEGONHEIRO",
      "GAIOLA",
      "HOPPER",
      "MUNCK",
      "SILO",
      "TANQUE",
    ],
  };

  const renderCategoriesBodyWork = () => {
    return Object.keys(categoriesBodyWork).map((category) => {
      const filteredOptions = typeBodyworkList.dados.filter((vehicle) =>
        categoriesBodyWork[category].includes(vehicle.name)
      );
      return (
        <Card className="mb-3" sx={{ border: "none", boxShadow: "none" }}>
          <div key={category} class="category-column">
            <h8 style={{ fontWeight: "bold", fontSize: "14px" }}>{category}</h8>
            {renderCheckboxListBodyWork(filteredOptions, "dados")}
          </div>
        </Card>
      );
    });
  };

  // ===================== [ handleUpload ]======================
  const handleUpload = (file) => {
    if (!file) return;

    const storageRef = ref(
      storage,
      // Usar o ID do frete (id) e o ID do ponto de parada (referenc)
      `freight/${id}/stoppingPoints/${referenc}/attachments/${file.name}`
    );

    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setCarregando(progress);
      },
      (error) => {
        alert(error);
        setCarregando(0); // Resetar carregamento em caso de erro
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          const fileName = file.name;
          const fileType = fileName.split(".").pop().toLowerCase();
          const createdAtClient = new Date();

          const attachmentData = {
            createdAt: createdAtClient,
            name: fileName,
            type: fileType,
            url: downloadURL,
          };

          setFormFields((currentFormFields) => {
            const updatedFormFields = currentFormFields.map((field) => {
              if (field.id === referenc) {
                // Encontrou o ponto de parada correto
                return {
                  ...field,

                  // canhoto: [...(field.canhoto || []), attachmentData],

                  canhoto: downloadURL,

                  // attachments: [...(field.attachments || []), attachmentData],
                };
              }
              return field; // Retorna os outros campos sem modificação
            });
            return updatedFormFields; // Retorna o array atualizado
          });

          console.log(
            `Upload de ${file.name} concluído para ponto ${referenc}. Dados:`,
            attachmentData
          );

          // Limpar estado e fechar modal
          setCarregando(0);
          setOpenOrigem(false);
          setOrigem("");
          setReferenc("");
        });
      }
    );
  };

  const handleCloseModal = () => {
    setOpenOrigem(false);
  };

  const handleShipperCloseModal = () => {
    setOpenShipper(false);
  };

  const getDadaClient = (cnpj, razaosocial) => {
    setPayingCustomer(razaosocial || "");
    setCnpjPayingCustomer(cnpj);
  };

  /**
   * Função para atualizar os campos do formulário
   * @param {React.ChangeEvent} event - Evento de mudança do campo
   * @param {number} index - Índice do campo no array de campos
   */

  const handleFormChange = (event, index) => {
    const { name, value, type, checked } = event.target;

    // Verifica se o nome do campo e o índice são válidos
    if (!name || index < 0) {
      return;
    }

    // Usa a forma funcional do setState para garantir que trabalhamos com o estado mais recente
    // Isso evita race conditions quando outras funções também atualizam formFields
    setFormFields((prevFormFields) => {
      // Verifica se o índice é válido
      if (index >= prevFormFields.length) {
        return prevFormFields;
      }

      // Cria uma cópia do array de pontos de parada
      const newFormFields = [...prevFormFields];

      // Cria uma cópia do objeto do ponto de parada no índice especificado
      const updatedField = { ...newFormFields[index] };

      // Atualiza o campo modificado
      // Para checkboxes, usa 'checked', caso contrário usa 'value'
      const fieldValue = type === 'checkbox' ? checked : (value || '');
      updatedField[name] = fieldValue;

      // Atualiza o objeto no array
      newFormFields[index] = updatedField;

      // Retorna o novo array
      return newFormFields;
    });
  };


  const deleteItem = (item, index) => {
    setFormFields((prev) => {
      const data = [...prev];
      data.splice(index, 1);
      return data;
    });
  };

  const duplicateForm = (index) => {
    setFormFields((prev) => {
      // Pega o formulário que será duplicado
      const formToDuplicate = prev[index];

      // Verifica se o formulário a ser duplicado existe
      if (!formToDuplicate) {
        console.error("Formulário não encontrado no índice:", index);
        return prev;
      }

      // Cria uma cópia profunda do formulário original
      let newForm = JSON.parse(JSON.stringify(formToDuplicate));

      // Modifica os campos específicos do novo formulário
      newForm.stop_order = formToDuplicate.stop_order + 1;
      newForm.date_operation = "";
      newForm.time_operation = "";
      newForm.observation = "";
      newForm.number_collect = geraNumeroColeta();
      newForm.manualCoordinatesEnabled = false;

      // Adiciona o novo formulário à lista de formulários
      return [...prev, newForm];
    });
  };

  // Função para formatar o CPF
  const formatCPF = (cpf) => {
    if (!cpf) return "";
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  /**
   * Função para verificar se os campos do formulário de pontos de parada
   * estão preenchidos corretamente.
   * Verifica se todos os campos obrigatórios de cada ponto de parada
   * foram preenchidos.
   * @returns {array} Vetor com os nomes dos campos inválidos
   */
  const getInvalidFields = () => {
    const erros = [];

    // 1. Validação de Campos Simples (Pagador, Valores, Veículo, Frete)
    const simpleFields = [
      // --- Pagador ---
      { value: payingCustomer, label: "Cliente Pagador", id: "chose-1" },
      {
        value: cnpjPayingCustomer,
        label: "CNPJ do Pagador",
        id: "cnpjPayingCustomer",
      },

      // --- Veículo ---
      { value: occupation, label: "Ocupação", id: "occupation" },
      {
        value: freeOfCharge,
        label: "Livre de Carga e Descarga",
        id: "freeOfCharge",
      },

      // --- Motorista (Valores Básicos) ---
      {
        value: valueDriverInitial,
        label: "Valor Sugerido (Motorista)",
        id: "valueDriverInitial",
      },
      {
        value: valueDriverFinal,
        label: "Valor Anunciado (Motorista)",
        id: "valueDriverFinal",
      },

      // --- Dados do Frete ---
      { value: seller, label: "Vendedor", id: "seller" },
      // { value: operational, label: "Operacional", id: "operational" },
      // {
      //   value: phoneRespContractFreigtage,
      //   label: "Resp. Contratação Frete",
      //   id: "phoneRespContractFreigtage",
      // },
      { value: weightCargo, label: "Peso da Carga", id: "weightCargo" },
      { value: valueNF, label: "Valor da NF", id: "valueNF" },
      {
        value: valueFreightage,
        label: "Valor do Frete",
        id: "valueFreightage",
      },
    ];

    // Verifica lista simples
    simpleFields.forEach((field) => {
      if (
        !field.value ||
        field.value === 0 ||
        (typeof field.value === "string" && field.value.trim() === "")
      ) {
        erros.push(field.label);
      }
    });

    // Se existe um uidDriver, estes campos tornam-se obrigatórios para status "Contratado"
    if (uidDriver && uidDriver !== "") {
      if (!valueNegotiated || valueNegotiated === 0) {
        erros.push("Valor Negociado (Obrigatório ao selecionar motorista)");
      }
      if (!paymentCondition) {
        erros.push(
          "Condição de Pagamento (Obrigatório ao selecionar motorista)"
        );
      }
    }

    // 3. Validação de Arrays Pontos de Parada
    if (!formFields || formFields.length === 0) {
      erros.push("Pontos de Parada (Adicione pelo menos um ponto)");
    } else {
      formFields.forEach((stop, index) => {
        const stopNum = stop.stop_order || index + 1;

        // Validações Gerais do Ponto
        if (!stop.name) erros.push(`Ponto ${stopNum}: Nome/Razão Social`);
        if (!stop.cpf_cnpj) erros.push(`Ponto ${stopNum}: CNPJ/CPF`);
        if (!stop.cep) erros.push(`Ponto ${stopNum}: CEP`);
        if (!stop.logradouro) erros.push(`Ponto ${stopNum}: Endereço`);
        if (!stop.number) erros.push(`Ponto ${stopNum}: Número`);
        if (!stop.city) erros.push(`Ponto ${stopNum}: Cidade`);
        if (!stop.uf) erros.push(`Ponto ${stopNum}: UF`);

        // Datas são cruciais para a logística
        if (!stop.date_operation)
          erros.push(`Ponto ${stopNum}: Data da Coleta/Entrega`);
        // if (!stop.time_operation)
        //   erros.push(`Ponto ${stopNum}: Hora da Coleta/Entrega`);

        // Validação da Operação (Carga/Descarga)
        if (!stop.operation || stop.operation.length === 0) {
          erros.push(`Ponto ${stopNum}: Selecione Carga ou Descarga`);
        }

        // Regra específica: Se for CARGA, precisa de Tipo e Descrição
        if (stop.operation && stop.operation.includes("carga")) {
          if (!stop.type)
            erros.push(
              `Ponto ${stopNum}: Tipo da Carga (Obrigatório para Carga)`
            );
          if (!stop.descricao)
            erros.push(`Ponto ${stopNum}: Descrição (Obrigatório para Carga)`);
        }
      });
    }

    // Validação de Checkboxes de Veículos
    const hasSelectedVehicle = tipoVeiculo.dados.some((v) => v.selected);
    if (!hasSelectedVehicle) {
      // erros.push("Tipo de Veículo (Selecione pelo menos um)");
    }

    return erros;
  };

  /**
   * Função para tratar erros de campos obrigatórios
   * e exibir mensagem de erro para o usuário.
   * Se houver campos obrigatórios faltando, mostra
   * uma mensagem de erro com todos os campos faltando
   * de uma vez e para a execução. Caso contrário,
   * chama a função de salvar original.
   */
  const handleSave = () => {
    const camposInvalidos = getInvalidFields();

    if (camposInvalidos.length > 0) {
      // Exibe alerta com todos os campos faltando de uma vez
      setTitle("Campos( obrigatórios faltando");
      showMessage([
        "Alguns campos são de preenchimento obrigatório:",
        ...camposInvalidos,
      ]);
      setStatus("error");
      setOpen(true);
      setLoading(false);
      return; // Para a execução e não salva
    }

    // Se passou, chama a função de salvar original

    idVerify === null || idVerify === undefined ? save() : update(false);
  };


  return (
    <div className="min-h-screen  " style={{ backgroundColor: "#F9FAFB" }}>
      <>
        {useSelector((state) => state.usuarioLogado) > 0 ? (
          <NewMiniDrawer
            divOpen={
              <Box
                component="span"
                sx={{
                  display: "inline-block",
                  mx: "1px",
                  transform: "scale(1.0)",
                }}
              >
                <div
                  className="freight-content align-items-center"
                  style={{ paddingTop: "0px" }}
                >
                  {/* Dialog de upload de arquivo  */}
                  <AlertDialogFreight
                    handleClose={handleCloseModal}
                    open={openOrigem}
                    origem={origem}
                    handleUpload={handleUpload}
                    operationType={currentOperationType}
                  />

                  <ShipperDialog
                    handleClose={handleShipperCloseModal}
                    open={openShipper}
                    dadosClient={getDadaClient}
                  />

                  <div className="container">
                    <div className="row">
                      <div className="col-5">
                        <p className="help-block">
                          {" "}
                          Número Orçamento: <strong>
                            {" "}
                            {numberSerial}{" "}
                          </strong>{" "}
                        </p>
                      </div>
                      <div className="col-5"></div>
                      <div className="col-2">
                        <div className="col-md-11 control-label">
                          <p className="help-block">
                            <span className="h11">*</span>
                            <strong> Campo Obrigatório </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row g-12">
                    <div
                      // class="btn-group"
                      role="group"
                      aria-label="Basic radio toggle button group"
                    >
                      {/* <HorizontalStepper status={code} /> */}

                      <ModernStepper propsStatus={code} />
                    </div>

                    <hr className="my-4" />
                  </div>


                  <Card
                    sx={{ padding: 2 }}
                    className="form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                    style={{
                      background: "#ffffff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "16px",
                    }}
                  >
                    <div className="form-signin mx-auto mb-4 mb-lg-6">
                      {/* <h4 className="mb-3"> <AttachMoneyIcon fontSize="medium" /> Pagador</h4> */}

                      <h4
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                        className="mb-3"
                      >
                        <AttachMoneyIcon fontSize="medium" /> Pagador
                      </h4>

                      <div className="row justify-content-center align-items-center gx-3">
                        <div className="col-4">
                          <label
                            htmlFor="payingCustomerLabel"
                            className="font-test"
                          >
                            Cliente <span style={{ color: "red" }}>*</span>
                          </label>

                          <Autocomplete
                            id="chose-1"
                            size="small"
                            disabled={view}
                            value={listECShipper && listECShipper}
                            getOptionLabel={getShipperOptionLabel}
                            // O autocomplete do pagador deve pesquisar apenas por nome fantasia.
                            options={listShipper} // Use listShipper directly
                            filterOptions={filterShipperByFantasyName}
                            isOptionEqualToValue={(option, value) =>
                              option?.id === value?.id
                            }
                            on
                            onChange={(event, value) => {
                              handleChangeClient(value);

                              setPayingCustomer(
                                getShipperDisplayName(value)
                              );
                            }}
                            noOptionsText="Nenhum Embarcador com esse nome foi encontrado"
                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                              <TextField {...params} label="" />
                            )}
                          />
                        </div>

                        <div className="col-md-3">
                          <label
                            htmlFor="cnpjPayingCustomerLabel"
                            className="font-test"
                          >
                            CNPJ <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            disabled={view}
                            type="text"
                            name="cnpjPayingCustomer"
                            onChange={(e) =>
                              setCnpjPayingCustomer(e.target.value)
                            }
                            value={cnpjPayingCustomer && cnpjPayingCustomer}
                            className="form-control"
                            id="cnpjPayingCustomer"
                          />
                        </div>
                      </div>
                    </div>
                  </Card>

                  {/** PONTOS DE PARADAS */}

                  <div className="row g-12 ">
                    <div
                      className="form-signin mx-auto mb-4 mb-lg-6"
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                      }}
                    >
                      <h4
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                        className="mt-3 ml-12 mb-3"
                      >
                        <LocationOnIcon
                          style={{ color: "#043124" }}
                          fontSize="medium"
                        />{" "}
                        Pontos de paradas
                      </h4>

                      <div className="form-signin mx-auto mb-4 mb-lg-6 ">
                        {[...formFields]
                          .sort((a, b) => a.stop_order - b.stop_order)
                          .map((form, index) => {

                            const indiceReal = formFields.findIndex(item => item.number_collect === form.number_collect);
                            return (
                              <Box
                                component="span"
                                sx={{
                                  display: "inline-block",
                                  mx: "1px",
                                  transform: "scale(0.9)",
                                }}
                                className="form-signin"
                              >
                                <Card
                                  className="form-signin mx-auto mb-4  mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3 align-items-center"
                                  style={{
                                    background: form.canhoto
                                      ? "#f2f8fb"
                                      : "#ffffff",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                    borderRadius: "16px",
                                  }}
                                >
                                  <div className="row mb-5">
                                    <Spin spinning={loading} size="Large">
                                      <div className="row">
                                        <div className="col-1 mb-4">
                                          <label
                                            htmlFor="ordenacaoLabel"
                                            className="font-test"
                                          >
                                            Ordenação
                                          </label>
                                          <input
                                            disabled={view}
                                            type="number"
                                            name="stop_order"
                                            min={1}
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                            value={
                                              form.stop_order && form.stop_order
                                            }
                                            // disabled={form.concluded && isCopy !== "true"}
                                            size={"small"}
                                            className="form-control"
                                            id="ordenacao"
                                            placeholder=""
                                          />
                                        </div>

                                        <div className="col-1 mb-2"></div>

                                        <div className="col-3 mb-2">
                                          <FormControl component="fieldset">
                                            <FormLabel id="demo-row-radio-buttons-group-label">
                                              <label className="font-test">
                                                Tipo de Parada{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                            </FormLabel>
                                            <div className="row">
                                              <div className="col-6 mb-2">
                                                <FormControlLabel
                                                  disabled={view}
                                                  value="carga"
                                                  name="carga"
                                                  // disabled={form.concluded && isCopy !== "true"}
                                                  // disabled={form.operation.includes("descarga")}
                                                  onChange={(event) => {
                                                    handleFormChange(
                                                      event,
                                                      indiceReal,
                                                      "carga"
                                                    );
                                                    handleNameButtonImport(
                                                      "carga"
                                                    );
                                                    handleCheckBoxChange(
                                                      event,
                                                      indiceReal
                                                    );
                                                  }}
                                                  // control={<Checkbox value={form.typeCarga && form.typeCarga}  />}
                                                  control={
                                                    <Checkbox
                                                      // disabled={disabledCheckBox}
                                                      value={
                                                        form.operation[0] &&
                                                        form.operation[0]
                                                      }
                                                      // checked={
                                                      //   form.operation[1] ===
                                                      //     "carga" ||
                                                      //     form.operation[0] ===
                                                      //     "carga"
                                                      //     ? true
                                                      //     : false
                                                      // }
                                                      checked={form.operation.includes(
                                                        "carga"
                                                      )}
                                                      disabled={form.operation.includes(
                                                        "descarga"
                                                      )}
                                                    />
                                                  }
                                                  label="Carga"
                                                />
                                              </div>
                                              <div className="col-6 mb-2">
                                                <FormControlLabel
                                                  disabled={view}
                                                  value="descarga"
                                                  name="descarga"
                                                  // disabled={form.concluded && isCopy !== "true"}
                                                  onChange={(event) => {
                                                    handleFormChange(
                                                      event,
                                                      indiceReal,
                                                      "descarga"
                                                    );

                                                    handleNameButtonImport(
                                                      "descarga"
                                                    );
                                                    handleCheckBoxChange(
                                                      event,
                                                      indiceReal
                                                    );
                                                  }}
                                                  // control={<Checkbox value={form.typeDescarga && form.typeDescarga}  />}
                                                  control={
                                                    <Checkbox
                                                      value={
                                                        form.operation[1] &&
                                                        form.operation[1]
                                                      }
                                                      // checked={
                                                      //   form.operation[1] ===
                                                      //     "descarga" ||
                                                      //     form.operation[0] ===
                                                      //     "descarga"
                                                      //     ? true
                                                      //     : false
                                                      // }
                                                      checked={form.operation.includes(
                                                        "descarga"
                                                      )}
                                                      disabled={form.operation.includes(
                                                        "carga"
                                                      )}
                                                    />
                                                  }
                                                  label="Descarga"
                                                />
                                              </div>
                                            </div>
                                          </FormControl>
                                        </div>

                                        <div className="col-6 mb-2">
                                          <FormGroup>
                                            {/* <FormControlLabel style={{color: 'red'}} control={<Switch name="verify" 
                                                                                                checked={form.verify ? true : false} 
                                                                                                onChange={event => handleFormChange(event, index)} />} 
                                                                                                label="Motorista realizou a carga ou a descarga ?" /> */}
                                          </FormGroup>
                                        </div>

                                        <div
                                          className="col-1 mb-2"
                                          direction="row"
                                        >
                                          <div>
                                            <FormGroup>
                                              <Stack spacing={1}>
                                                <IconButton
                                                  disabled={view}
                                                  size="large"
                                                  onClick={() =>
                                                    duplicateForm(indiceReal)
                                                  }
                                                  color="primary"
                                                  aria-label="duplicate"
                                                >
                                                  <ContentCopyIcon />
                                                </IconButton>
                                              </Stack>
                                            </FormGroup>
                                          </div>
                                          <div>
                                            <FormGroup>
                                              <Stack spacing={1}>
                                                <IconButton
                                                  disabled={view}
                                                  size="large"
                                                  onClick={(e) => {
                                                    deleteItem(form, indiceReal);
                                                  }}
                                                  color="error"
                                                  aria-label="delete"
                                                >
                                                  <DeleteForeverIcon />
                                                </IconButton>
                                              </Stack>
                                            </FormGroup>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-4">
                                          <label
                                            htmlFor="cnpjLabel"
                                            className="font-test"
                                          >
                                            CNPJ{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </label>
                                          <input
                                            disabled={view}
                                            type="text"
                                            name="cpf_cnpj"
                                            // disabled={form.concluded && isCopy !== "true"}
                                            onChange={(event) => {
                                              buscarCNPJBancoClient(
                                                event.target.value,
                                                indiceReal
                                              );
                                              handleFormChange(event, indiceReal);
                                            }}
                                            value={
                                              form.cpf_cnpj && form.cpf_cnpj
                                            }
                                            className="form-control"
                                            id="cnpj"
                                            placeholder=""
                                          />
                                        </div>

                                        <div className="col-8">
                                          <label
                                            htmlFor="nomeLabel"
                                            className="font-test"
                                          >
                                            Nome{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </label>
                                          <input
                                            disabled={view}
                                            type="text"
                                            // disabled={form.concluded && isCopy !== "true"}
                                            name="name"
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                            value={form.name && form.name}
                                            className="form-control"
                                            id="name"
                                            placeholder=""
                                          />
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-2">
                                          <label
                                            htmlFor="cepLabel"
                                            className="font-test"
                                          >
                                            CEP{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </label>
                                          <input
                                            disabled={view}
                                            type="text"
                                            name="cep"
                                            onChange={(event) => {
                                              // atualiza pelo que o usuário digita usando o índice real
                                              handleFormChange(event, indiceReal);

                                              // Só dispara a busca se tiver 8 dígitos numéricos
                                              const rawValue = event.target.value.replace(/\D/g, "");
                                              if (rawValue.length === 8) {
                                                buscarCepPaying(rawValue, indiceReal);
                                              }
                                            }}
                                            value={form.cep || ""}
                                            maxLength={9}
                                            className="form-control"
                                            id="cep"
                                            onBlur={(event) =>
                                              handleStopPointAddressBlur(
                                                indiceReal,
                                                event.target.name,
                                                event.target.value
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-4">
                                          <label
                                            htmlFor="addressLabel"
                                            className="font-test"
                                          >
                                            Endereço{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </label>
                                          <input
                                            disabled={view}
                                            type="text"
                                            // disabled={form.concluded && isCopy !== "true"}
                                            name="logradouro"
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                            onBlur={(event) =>
                                              handleStopPointAddressBlur(
                                                indiceReal,
                                                event.target.name,
                                                event.target.value
                                              )
                                            }
                                            value={
                                              form.logradouro && form.logradouro
                                            }
                                            className="form-control"
                                            id="address"
                                          />
                                        </div>

                                        <div className="col-md-1">
                                          <label
                                            htmlFor="numberLabel"
                                            className="font-test"
                                          >
                                            N.º{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </label>
                                          <input
                                            disabled={view}
                                            type="text"
                                            // disabled={form.concluded && isCopy !== "true"}
                                            name="number"
                                            onChange={(event) => {
                                              handleFormChange(event, indiceReal);
                                              consultStreetByStreet(indiceReal);
                                            }}
                                            value={form.number && form.number}
                                            className="form-control"
                                            id="numberAddress"
                                          />
                                        </div>

                                        <div className="col-2">
                                          <label
                                            htmlFor="city"
                                            className="font-test"
                                          >
                                            Cidade{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </label>
                                          <input
                                            disabled={view}
                                            type="text"
                                            // disabled={form.concluded && isCopy !== "true"}
                                            name="city"
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                            onBlur={(event) =>
                                              handleStopPointAddressBlur(
                                                indiceReal,
                                                event.target.name,
                                                event.target.value
                                              )
                                            }
                                            value={form.city && form.city}
                                            className="form-control"
                                            id="cityAddress"
                                            placeholder=""
                                          />
                                        </div>

                                        <div className="col-md-1">
                                          <label
                                            htmlFor="stateInitialLabel"
                                            className="font-test"
                                          >
                                            Estado{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </label>
                                          <input
                                            disabled={view}
                                            type="text"
                                            // disabled={form.concluded && isCopy !== "true"}
                                            name="uf"
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                            onBlur={(event) =>
                                              handleStopPointAddressBlur(
                                                indiceReal,
                                                event.target.name,
                                                event.target.value
                                              )
                                            }
                                            value={form.uf && form.uf}
                                            className="form-control"
                                            id="stateInitial"
                                          />
                                        </div>

                                        <div className="col-md-2">
                                          <label
                                            htmlFor="stateInitialLabel"
                                            className="font-test"
                                          >
                                            Atualizar
                                          </label>
                                          {form.checkItemLocation ? (
                                            <Stack direction="row">
                                              <Button
                                                disabled={view}
                                                variant="contained"
                                                size="small"
                                                onClick={(e) => {
                                                  consultStreetByStreet(indiceReal);
                                                }}
                                                color="success"
                                                // disabled={form.concluded && isCopy !== "true"}
                                                startIcon={
                                                  <CheckCircleOutlineIcon />
                                                }
                                              >
                                                Atualizado!
                                              </Button>
                                            </Stack>
                                          ) : (
                                            <Stack direction="row">
                                              <Button
                                                disabled={view}
                                                sx={{
                                                  backgroundColor: "#012443",
                                                }}
                                                variant="contained"
                                                size="small"
                                                onClick={(e) => {
                                                  consultStreetByStreet(indiceReal);
                                                }}
                                                color="primary"
                                                // disabled={form.concluded && isCopy !== "true"}
                                                startIcon={<LoopIcon />}
                                              >
                                                Atualizar
                                              </Button>
                                            </Stack>
                                          )}
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-md-3">
                                          <label
                                            htmlFor="responsibleLabel"
                                            className="font-test"
                                          >
                                            Responsável
                                          </label>
                                          <input
                                            disabled={view}
                                            type="text"
                                            name="responsible_name"
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                            // disabled={form.concluded && isCopy !== "true"}
                                            value={
                                              form.responsible_name &&
                                              form.responsible_name
                                            }
                                            className="form-control"
                                            id="responsible"
                                          />
                                        </div>

                                        <div className="col-3">
                                          <label
                                            htmlFor="phoneRespLabel"
                                            className="font-test"
                                          >
                                            Telefone Responsável
                                          </label>
                                          <InputMask
                                            disabled={view}
                                            mask="(99) 99999-9999"
                                            id="phoneResp"
                                            className="form-control"
                                            name="responsible_phone"
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                            // disabled={form.concluded && isCopy !== "true"}
                                            value={
                                              form.responsible_phone &&
                                              form.responsible_phone
                                            }
                                            placeholder="(99) 99999-9999"
                                          />
                                        </div>

                                        <div className="col-md-2">
                                          <label
                                            htmlFor="numberColetaLabel"
                                            className="font-test"
                                          >
                                            Número da coleta{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </label>
                                          <input
                                            disabled={view}
                                            type="text"
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                            // disabled={form.concluded && isCopy !== "true"}
                                            name="number_collect"
                                            value={
                                              form.number_collect &&
                                              form.number_collect
                                            }
                                            className="form-control"
                                            id="numbercoleta"
                                          />
                                        </div>

                                        <div className="col-md-2 mb-4">
                                          <label
                                            htmlFor="datacoletaLabel"
                                            className="font-test"
                                          >
                                            Data da Coleta
                                          </label>
                                          <input
                                            disabled={view}
                                            type="date"
                                            name="date_operation"
                                            // disabled={form.concluded && isCopy !== "true"}
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                            value={
                                              form.date_operation || ""
                                            }
                                            className="form-control"
                                            id="datacoleta"
                                          />
                                        </div>

                                        <div className="col-md-2 mb-4">
                                          <label
                                            htmlFor="horacoletaLabel"
                                            className="font-test"
                                          >
                                            Hora da Coleta
                                          </label>

                                          <InputMask
                                            disabled={view}
                                            mask="99:99"
                                            id="phoneResp"
                                            className="form-control"
                                            name="time_operation"
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                            // disabled={form.concluded && isCopy !== "true"}
                                            value={
                                              form.time_operation &&
                                              form.time_operation
                                            }
                                            placeholder="99:99"
                                          />
                                        </div>
                                      </div>

                                      {/* ===================================================================================== */}

                                      <div className="row">
                                        <div className="col-md-3 mb-2">
                                          {" "}
                                          <label
                                            htmlFor="Latitude"
                                            className="font-test"
                                          >
                                            Latitude
                                          </label>
                                          <input
                                            type="text"
                                            name="latitude"
                                            disabled={
                                              !form.manualCoordinatesEnabled
                                            }
                                            value={
                                              form.latitude && form.latitude
                                            }
                                            className="form-control"
                                            id="latitude"
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                          />
                                        </div>
                                        <div className="col-md-3 mb-4">
                                          {" "}
                                          <label
                                            htmlFor="Longitude"
                                            className="font-test"
                                          >
                                            Longitude
                                          </label>
                                          <input
                                            type="text"
                                            disabled={
                                              !form.manualCoordinatesEnabled
                                            }
                                            name="longitude"
                                            value={
                                              form.longitude && form.longitude
                                            }
                                            className="form-control"
                                            id="longitude"
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                          />
                                        </div>

                                        {form.operation.includes("carga") && (
                                          <>
                                            <div
                                              // style={{ marginLeft: "175px" }}
                                              className="col-md-2 mb-4"
                                            >
                                              <label
                                                htmlFor="Tipo"
                                                className="font-test"
                                              >
                                                {" "}
                                                Tipo{" "}
                                              </label>
                                              <select
                                                disabled={view}
                                                className="form-select"
                                                onChange={(e) => {
                                                  const value =
                                                    e.target.value || "";
                                                  setFormFields((prev) => {
                                                    const newFormFields = [...prev];
                                                    newFormFields[indiceReal].type = value;
                                                    return newFormFields;
                                                  });
                                                }}
                                                value={form.type && form.type}
                                                aria-label=""
                                              >
                                                <option defaultValue="">
                                                  Selecione
                                                </option>
                                                <option value="01">
                                                  01 - Granel Sólido
                                                </option>
                                                <option value="02">
                                                  02 - Granel líquido
                                                </option>
                                                <option value="03">
                                                  03 - Frigorificada
                                                </option>
                                                <option value="04">
                                                  04 - Conteinerizada
                                                </option>
                                                <option value="05">
                                                  05 - Carga Geral
                                                </option>
                                                <option value="06">
                                                  06 - Neogranel
                                                </option>
                                                <option value="07">
                                                  07 - Perigosa (granel sólido)
                                                </option>
                                                <option value="08">
                                                  08 - Perigosa (granel líquido)
                                                </option>
                                                <option value="09">
                                                  09 - Perigosa (carga
                                                  frigorificada)
                                                </option>
                                                <option value="10">
                                                  10 - Perigosa (conteinerizada)
                                                </option>
                                                <option value="11">
                                                  11 - Perigosa (carga geral)
                                                </option>
                                              </select>
                                            </div>

                                            <div className="col-md-3 mb-4">
                                              <label
                                                htmlFor="descricao"
                                                className="font-test"
                                              >
                                                Descrição
                                              </label>
                                              <input
                                                disabled={view}
                                                type="text"
                                                name="descricao"
                                                className="form-control"
                                                value={
                                                  form.descricao &&
                                                  form.descricao
                                                }
                                                onChange={(e) => {
                                                  const value =
                                                    e.target.value || "";
                                                  setFormFields((prev) => {
                                                    const newFormFields = [...prev];
                                                    newFormFields[indiceReal].descricao = value;
                                                    return newFormFields;
                                                  });
                                                }}
                                                placeholder="Descrição do ponto"
                                              />
                                            </div>
                                          </>
                                        )}
                                      </div>

                                      <div className="row">
                                        <div className="col-md-3 mb-4">
                                          <div
                                            className="d-flex align-items-center"
                                            style={{ height: "0px" }}
                                          >
                                            <label
                                              htmlFor="Geoposição"
                                              className="font-test "
                                            >
                                              Informar Geolocalização
                                            </label>

                                            <Checkbox
                                              disabled={view}
                                              id={`geoposicao-${index}`}
                                              checked={
                                                !!form.manualCoordinatesEnabled
                                              }
                                              onChange={(event, isChecked) => {
                                                const syntheticEvent = {
                                                  target: {
                                                    name: "manualCoordinatesEnabled",
                                                    value: isChecked,
                                                    type: "checkbox",
                                                  },
                                                };
                                                // Chame a handleFormChange com o evento simulado e o índice
                                                handleFormChange(
                                                  syntheticEvent,
                                                  indiceReal
                                                );
                                              }}
                                            />
                                          </div>
                                        </div>

                                        <div className="col-md-3 mb-4">
                                          <div
                                            className="d-flex align-items-center"
                                            style={{ height: "0px" }}
                                          >
                                            {" "}
                                            <a
                                              style={{ cursor: "pointer" }}
                                              href={`https://www.google.com/maps/search/?api=1&query=${form.latitude},${form.longitude}`}
                                              target="_blank"
                                              rel="noreferrer noopener"
                                            >
                                              <label
                                                style={{ cursor: "pointer" }}
                                                className="font-test mb-0"
                                              >
                                                Visualizar no Mapa
                                              </label>
                                            </a>
                                          </div>
                                        </div>
                                      </div>

                                      {/* ===================================================================== */}

                                      <div className="row">
                                        <div className="col-md-12 mb-2">
                                          <label
                                            htmlFor="observation"
                                            className="font-test"
                                          >
                                            Observação
                                          </label>
                                          <TextArea
                                            disabled={view}
                                            name="observation"
                                            value={
                                              form.observation &&
                                              form.observation
                                            }
                                            // disabled={form.concluded && isCopy !== "true"}
                                            onChange={(event) =>
                                              handleFormChange(event, indiceReal)
                                            }
                                          />
                                        </div>

                                        <div className="row justify-content-between align-items-center gx-3 ">
                                          {form.canhoto ? (
                                            <>
                                              {/* <div className="row">
                                                <div className="col-md-6">
                                                  <label
                                                    htmlFor="datacoletaLabel"
                                                    className="form-label"
                                                  >
                                                    Canhoto
                                                  </label>
                                                  <CanhotoViewer
                                                    source={form.canhoto}
                                                  />
                                                  <Button
                                                                                                disabled={view}
                                                    variant="outlined"
                                                    onClick={(e) => {
                                                      setReferenc(null);
                                                      handleClickOpen(form.id);
                                                      setOrigem("Canhoto");
                                                    }}
                                                  >
                                                    Editar
                                                  </Button>
                                                </div>

                                                <div className="col-md-4"></div>
                                              </div> */}

                                              <GalleryDialog
                                                data={form.canhoto}
                                              />
                                            </>
                                          ) : (
                                            <>
                                              {id ? (
                                                <div className="gap-2.5">
                                                  <span
                                                    className="font-test gap-2"
                                                    style={{ color: "red" }}
                                                  >
                                                    Ainda não há comprovante de
                                                    entrega
                                                  </span>
                                                  <Button
                                                    disabled={view}
                                                    variant="outlined"
                                                    onClick={(e) => {
                                                      setReferenc(null);
                                                      handleClickOpen(
                                                        form.id,
                                                        form.operation[0]
                                                      );
                                                      setOrigem("Canhoto");
                                                    }}
                                                  >
                                                    {nameButtonImport}
                                                  </Button>
                                                </div>
                                              ) : (
                                                // <label>"" </label>
                                                ""
                                              )}
                                            </>
                                          )}
                                        </div>

                                        {/* <div className="col-md-4">
                                                                        {
                                                                            form.canhoto && !form.verify ? 
                                                                                <Box sx={{ width: '100%', maxWidth: 500, padding: 4, color: 'red' }}>
                                                                                    <Typography variant="h7" gutterBottom>
                                                                                        Este ponto de parada está pronto para ser verificado, por favor confirme com a empresa responsável e marque como verificada. 
                                                                                    </Typography>
                                                                                </Box>
                                                                            : 
                                                                            ""
                                                                        }
                                                                    </div> */}
                                      </div>
                                    </Spin>
                                  </div>
                                </Card>
                              </Box>
                            );
                          })}
                        <div className="row">
                          <div className="col-8"></div>
                          <div className="col-4">
                            <Button
                              variant="contained"
                              style={{ backgroundColor: "#012443" }}
                              disabled={view}
                              onClick={addFields}
                            >
                              {" "}
                              <AddIcon style={{ color: "#ff3100" }} /> pontos de
                              paradas{" "}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Veículo */}
                    <Card
                      sx={{ padding: 2 }}
                      className="form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                        width: "100%",
                      }}
                    >
                      <h4 className="mb-3">
                        <LocalShippingIcon className="localShippingIcon" />{" "}
                        Veículo
                      </h4>

                      <div className="container mt-4">
                        <div className="row justify-content-center">
                          <div className="col-lg-10 col-md-12">
                            <strong>
                              <label
                                htmlFor="occupation"
                                className="form-label h5 mb-3"
                              >
                                <Chip
                                  label="Tipo de Veículo"
                                  sx={{
                                    backgroundColor: "#012443",
                                    color: "white",
                                    fontWeight: "bold",
                                    border: "2px solid #FF3100",
                                    width: 150,
                                    height: 30,
                                    whiteSpace: "normal",
                                    justifyContent: "center",

                                    // Estilizando elementos internos (slots)
                                    "& .MuiChip-label": {
                                      fontSize: "0.9rem",
                                      paddingLeft: "4px",
                                      textAlign: "center",
                                    },
                                  }}
                                />{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </strong>

                            <div className="left-section">
                              {renderCategories()}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="container mt-4">
                        <div className="row justify-content-center">
                          <div className="col-lg-10 col-md-12">
                            <strong>
                              <label
                                htmlFor="bodywork-label"
                                className="form-label h5 mb-3"
                              >
                                <Chip
                                  label="Tipo de Carroceria"
                                  sx={{
                                    backgroundColor: "#012443",
                                    color: "white",
                                    fontWeight: "bold",
                                    border: "2px solid #FF3100",
                                    width: 170,
                                    height: 30,
                                    whiteSpace: "normal",
                                    justifyContent: "center",

                                    "& .MuiChip-label": {
                                      fontSize: "0.9rem",
                                      paddingLeft: "4px",
                                      textAlign: "center",
                                    },
                                  }}
                                />{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </strong>

                            <div className="left-section">
                              {renderCategoriesBodyWork()}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row" style={{ marginTop: "2%" }}>
                        {/* Campo Ocupação */}
                        <div className="col-md-6 d-flex flex-column justify-content-center">
                          <label
                            style={{ fontWeight: "bold" }}
                            htmlFor="occupation"
                            className="form-label"
                          >
                            Ocupação <span style={{ color: "red" }}>*</span>
                          </label>

                          <div className="col-md-6">
                            <select
                              disabled={view}
                              className="form-select"
                              onChange={(e) => setOccupation(e.target.value)}
                              value={occupation || ""}
                            >
                              <option value="">Selecione</option>
                              <option value="Fracionado">Fracionado</option>
                              <option value="Dedicado">Dedicado</option>
                            </select>
                          </div>
                        </div>

                        {/* Campo Livre de Carga e Descarga */}
                        <div className="col-md-6 d-flex justify-content-end align-items-center">
                          <div className="free-charge-wrapper">
                            <label
                              htmlFor="freeOfCharge"
                              className="free-charge-title"
                            >
                              Livre de Carga e Descarga{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>

                            <div className="free-charge-group">
                              <input
                                disabled={view}
                                type="radio"
                                onChange={(e) =>
                                  setFreeOfCharge(e.target.value)
                                }
                                checked={freeOfCharge === "SIM"}
                                value="SIM"
                                className="free-charge-radio"
                                name="freeOfCharge"
                                id="btnFreeYes"
                                autoComplete="off"
                              />
                              <label
                                htmlFor="btnFreeYes"
                                className="free-charge-btn free-charge-yes"
                              >
                                SIM
                              </label>

                              <input
                                disabled={view}
                                type="radio"
                                onChange={(e) =>
                                  setFreeOfCharge(e.target.value)
                                }
                                checked={freeOfCharge === "NAO"}
                                value="NAO"
                                className="free-charge-radio"
                                name="freeOfCharge"
                                id="btnFreeNo"
                                autoComplete="off"
                              />
                              <label
                                htmlFor="btnFreeNo"
                                className="free-charge-btn free-charge-no"
                              >
                                NÃO
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>

                    <Card
                      sx={{ padding: 2, paddingLeft: 0 }}
                      className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#344d66] rounded-lg p-3 "
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                      }}
                    >
                      <h4 className="mb-3">
                        <InventoryIcon /> Precificação
                      </h4>
                      <div>
                        <ProductTable product={product} onChange={handleProductsChange} />
                      </div>
                    </Card>


                    {/* Motorista */}

                    <Card
                      sx={{ padding: 2, paddingLeft: 0 }}
                      className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#344d66] rounded-lg p-3 "
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                      }}
                    >
                      <h4 className="mb-3">
                        <DriveEtaIcon /> Motorista
                      </h4>
                      <div
                        className="row justify-content-between align-items-center gx-3 "
                        style={{ marginLeft: "-15px" }}
                      >
                        <div className="col-2">
                          <label
                            htmlFor="valueDriverInitial"
                            className="font-test"
                          >
                            Valor Sugerido:
                          </label>
                          <IntlCurrencyInput
                            disabled={view}
                            currency="BRL"
                            config={currencyConfig}
                            placeholder="00.00"
                            onChange={handleChangeInitial}
                            value={valueDriverInitial && valueDriverInitial}
                            className="form-control"
                            id="valueDriverInitial"
                            maxLength={12}
                          />
                        </div>
                    
                        <div className="col-2">
                          <label
                            htmlFor="valueDriverFinal"
                            placeholder="0,00"
                            className="font-test"
                          >
                            Valor Anunciado:{" "}
                          </label>
                          <IntlCurrencyInput
                            disabled={view}
                            currency="BRL"
                            config={currencyConfig}
                            placeholder="00.00"
                            onChange={handleChangeFinal}
                            value={valueDriverFinal && valueDriverFinal}
                            className="form-control"
                            id="valueDriverFinal"
                            maxLength={12}
                          />
                        </div>



                        <div className="col-2">
                          <label htmlFor="nameDriver" className="font-test">
                            Motorista
                          </label>
                          <Autocomplete
                            disabled={view}
                            id="chose-1"
                            size="small"
                            value={driverChose === "" ? "" : driverChose}
                            //  Aplica a formatação quando o item é selecionado no input
                            getOptionLabel={(option) =>
                              formatName(option.name || "")
                            }
                            options={[
                              {
                                name: "Não aplicar motorista",
                                cpf: "",
                                value: "",
                                id: "",
                                uid: "",
                              },
                              ...driversInFila,
                            ]}
                            isOptionEqualToValue={(option, value) =>
                              option.name === value.name
                            }
                            onChange={(event, value) => {
                              handleDriver(value);
                            }}
                            clearOnBlur
                            noOptionsText="Nenhum Motorista com esse nome foi encontrado"
                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                              <TextField {...params} label="" />
                            )}
                            // Aplica a formatação na lista de opções do dropdown
                            renderOption={(props, option) => (
                              <li {...props} key={option.id || "default"}>
                                {option.name && option.cpf
                                  ? `${formatName(
                                    option.name
                                  )} - CPF: ${formatCPF(option.cpf)}`
                                  : formatName(option.name)}
                              </li>
                            )}
                            filterOptions={(options, { inputValue }) => {
                              const normalizedInput = inputValue.trim();
                              const normalizedCPFInput =
                                normalizedInput.replace(/\D/g, "");

                              const isNumber =
                                normalizedCPFInput !== "" &&
                                !isNaN(normalizedCPFInput);

                              return options.filter((option) => {
                                if (isNumber) {
                                  return option.cpf.includes(
                                    normalizedCPFInput
                                  );
                                } else {
                                  // Aplica a formatação na lista de opções do dropdown
                                  const nameMatch = option.name
                                    ?.toLowerCase()
                                    .includes(normalizedInput.toLowerCase());
                                  return nameMatch;
                                }
                              });
                            }}
                          />
                        </div>

                        <div className="col-2">
                          <label
                            htmlFor="valueNegotiated"
                            placeholder="0,00"
                            className="font-test"
                          >
                            Valor Negociado:{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <IntlCurrencyInput
                            currency="BRL"
                            config={currencyConfig}
                            placeholder="00.00"
                            onChange={handleChangeValueNegotiated}
                            value={valueNegotiated && valueNegotiated}
                            className="form-control"
                            id="valueNegotiated"
                            disabled={verifyPayment || view}
                          />

                          {verifyPayment && (
                            <small className="text-danger">
                              O status do lançamento financeiro não permite
                              alteração!
                            </small>
                          )}
                        </div>
                        <div class="col-2">
                          <label
                            htmlFor="paymentCondition"
                            class="font-test"
                            placeholder="0,00"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            Condições de Pagamento:
                          </label>
                          <select
                            disabled={verifyPayment || view}
                            value={paymentCondition && paymentCondition}
                            id="paymentCondition"
                            className="form-select"
                            onChange={handleChangePaymentCondition}
                          >
                            <option value="">Selecione</option>
                            <option value="70/30">70%/30%</option>
                            <option value="80/20">80%/20%</option>
                            <option value="50/50">50%/50%</option>
                            <option value="0/100">0%/100%</option>
                          </select>
                        </div>
                      </div>
                    </Card>


                    <Card
                      sx={{ padding: 2, paddingLeft: 0 }}
                      className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#344d66] rounded-lg p-3 "
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                      }}
                    >
                      <h4 className="mb-3">
                        <GroupsIcon /> Grupos
                      </h4>

                      <div
                        className="row justify-content-between align-items-start gx-3"
                        style={{ marginLeft: "-15px" }}
                      >
                        <div className="col-12">

                          {shipperGroups.length === 0 ? (
                            <small className="text-muted">
                              Nenhum grupo disponível para este embarcador.
                            </small>
                          ) : (
                            <DragDropContext onDragEnd={handleDragEndGroups}>
                              <Droppable droppableId="groups">
                                {(provided) => (
                                  <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {shipperGroups.map((group, index) => (
                                      <Draggable
                                        key={group.idGroup}
                                        draggableId={group.idGroup}
                                        index={index}
                                        isDragDisabled={view}
                                      >
                                        {(provided) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className="d-flex justify-content-between align-items-center mb-2 p-2 border rounded"
                                            style={{
                                              width: 300,
                                              background: index === 0 ? "#e6f0ff" : "#f9f9f9",
                                              border:
                                                index === 0 ? "2px solid #012443" : "1px solid #ddd",
                                              cursor: view ? "not-allowed" : "grab",
                                              ...provided.draggableProps.style,
                                            }}
                                          >
                                            <div
                                              className="d-flex align-items-center gap-2"
                                              style={{ minWidth: 0 }}
                                            >
                                              {/* 🔢 NUMERAÇÃO (1,2,3,4...) */}
                                              <span
                                                style={{
                                                  minWidth: 24,
                                                  height: 24,
                                                  borderRadius: "50%",
                                                  background: "#012443",
                                                  color: "#fff",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  fontWeight: 700,
                                                  fontSize: 12,

                                                }}
                                              >
                                                {index + 1}
                                              </span>

                                              <span
                                                style={{
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  maxWidth: 260,
                                                }}
                                                title={getGroupName(group)}
                                              >
                                                {getGroupName(group)}
                                              </span>
                                            </div>

                                            {/* ✅ REMOVIDO: "ATIVO" */}
                                          </div>
                                        )}
                                      </Draggable>
                                    ))}

                                    {provided.placeholder}
                                  </div>
                                )}
                              </Droppable>
                            </DragDropContext>
                          )}
                        </div>
                      </div>
                    </Card>









                    {/* FRETE */}

                    <Card
                      sx={{ padding: 2 }}
                      className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                      }}
                    >
                      <h4 className="mb-3">
                        {" "}
                        <FireTruckOutlinedIcon /> Frete
                      </h4>

                      <div className="row justify-content-between align-items-center gx-3">
                        <div className="col-3">
                          <label htmlFor="seller" className="font-test">
                            Vendedor <span style={{ color: "red" }}>*</span>
                          </label>

                          <Autocomplete
                            disabled={view}
                            id="seller-select"
                            size="small"
                            options={sellersList}
                            getOptionLabel={(option) =>
                              typeof option === "string"
                                ? option
                                : formatName(option.name)
                            }
                            value={
                              sellersList.find(
                                (s) => sellerId && s.id === sellerId,
                              ) ||
                              sellersList.find((s) => s.name === seller) ||
                              seller
                            }
                            onChange={(event, newValue) => {
                              setSeller(newValue ? newValue.name : "");
                              setSellerId(newValue ? newValue.id || "" : "");
                            }}
                            // clearOnBlur
                            onInputChange={(event, newInputValue) => {
                              setSeller(newInputValue);
                              if (!newInputValue) {
                                setSellerId("");
                              }
                            }}
                            noOptionsText="Nenhum vendedor encontrado"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label=""
                                placeholder="Selecione o vendedor"
                                id="seller"
                              />
                            )}
                            isOptionEqualToValue={(option, value) =>
                              Boolean(option?.id && value?.id)
                                ? option.id === value.id
                                : option?.name === value?.name
                            }
                            forcePopupIcon={true}
                            popupIcon={<KeyboardArrowDownIcon />}
                          />
                        </div>

                        <div className="col-3">
                          <label htmlFor="operational" className="font-test">
                            Operacional
                          </label>
                          <input
                            disabled={true}
                            type="text"
                            onChange={(e) => setOperational(e.target.value)}
                            value={operational && operational}
                            className="form-control"
                            id="operational"
                            placeholder=""
                          />
                        </div>

                        <div className="col-2">
                          <label
                            htmlFor="phoneRespContractFreigtage"
                            className="font-test"
                          >
                            Resp. contratação frete
                          </label>
                          <InputMask
                            disabled={view}
                            mask="(99) 99999-9999"
                            className="form-control"
                            onChange={(e) =>
                              setPhoneRespContractFreigtage(e.target.value)
                            }
                            value={
                              phoneRespContractFreigtage &&
                              phoneRespContractFreigtage
                            }
                            placeholder="(99) 99999-9999"
                          />

                        </div>
                      </div>

                      <div className="row justify-content-between align-items-center gx-3">
                        <div className="col-md-2">
                          <label htmlFor="weightCargo" className="font-test">
                            Peso da Carga (Kg)
                          </label>
                          <IntlCurrencyInput
                            disabled={view}
                            currency="BRL"
                            config={weightConfig}
                            placeholder="00.00"
                            onChange={handleChangeWeightCargo}
                            value={weightCargo && weightCargo}
                            className="form-control"
                            id="weightCargo"
                            maxLength={10}
                          />
                        </div>

                        <div className="col-2">
                          <label htmlFor="valueNF" className="font-test">
                            Valor NF
                          </label>
                          <IntlCurrencyInput
                            disabled={view}
                            currency="BRL"
                            config={currencyConfig}
                            placeholder="00.00"
                            onChange={handleChangeValueNF}
                            value={valueNF && valueNF}
                            className="form-control"
                            id="valueNF"
                            maxLength={15}
                          />
                        </div>

                        <div className="col-2">
                          <label
                            htmlFor="valueFreightage"
                            className="font-test"
                          >
                            Valor do Frete
                          </label>
                          <IntlCurrencyInput
                            disabled={view}
                            currency="BRL"
                            config={currencyConfig}
                            placeholder="00.00"
                            onChange={handleChangeValueFreightage}
                            value={valueFreightage && valueFreightage}
                            className="form-control"
                            id="valueFreightage"
                            maxLength={12}
                          />
                          {
                            valueFreightage < product.reduce((acc, curr) => acc + (curr.amount * curr.priceList || 0), 0) &&
                            <small className="text-danger">
                              O valor do frete esta menor que o valor total dos produtos.
                            </small>
                          }
                        </div>
                      </div>
                    </Card>

                    {/* Dados da entrega */}
                    <Card
                      sx={{ padding: 2 }}
                      className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                      }}
                    >
                      <div className="form-signin mx-auto">
                        <div className="col-12">
                          <h4 className="mb-3">
                            {" "}
                            <StorageOutlinedIcon /> Dados da entrega
                          </h4>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <label htmlFor="observation" className="font-test">
                              Observações Motorista
                            </label>
                            <textarea
                              disabled={view}
                              className="form-control"
                              onChange={(e) => setObservation(e.target.value)}
                              value={observation || ""}
                              id="observation"
                              rows="3"
                              maxLength={300}
                            />
                            <div
                              className="text-end text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              {observation?.length || 0}/300
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-signin mx-auto">
                        <div className="row">
                          <div className="col-12">
                            <label
                              htmlFor="internalObservations"
                              className="font-test"
                            >
                              Observações internas
                            </label>
                            <textarea
                              disabled={view}
                              className="form-control"
                              onChange={(e) =>
                                setInternalObservations(e.target.value)
                              }
                              value={
                                internalObservations && internalObservations
                              }
                              id="internalObservations"
                              rows="3"
                              maxLength={300}
                            />
                            <div
                              className="text-end text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              {internalObservations?.length || 0}/300
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>

                  <div className="container">
                    <div className="row">
                      <div className="col-4"></div>
                      <div className="col-4"></div>
                      <div
                        className="col-4"
                        style={{
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        <div
                          className="btn-class-cadastrar"
                          style={{ flex: 1 }}
                        >
                          <Link to={"/freightlistCopy"}>
                            <BackButton />
                          </Link>
                        </div>

                        {id &&
                          (code === "04" || code === "05" || code === "06") ? (
                          <div
                            className="btn-class-cadastrar"
                            style={{ flex: 1 }}
                          >
                            {carregando ? (
                              <div
                                className="spinner-border text-danger"
                                role="status"
                              >
                                <span className="visually-hidden ">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <button
                                disabled={view}
                                type="submit"
                                onClick={(e) => update(true, false)}
                                className="w-100 btn btn-primary btn-cadastrar"
                              >
                                {"Finalizar"}
                              </button>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        <div
                          className="btn-class-cadastrar"
                          style={{ flex: 1 }}
                        >
                          {carregando ? (
                            <div
                              className="spinner-border text-danger"
                              role="status"
                            >
                              <span className="visually-hidden ">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <button
                              disabled={view || carregando}
                              type="submit"
                              onClick={(e) => handleSave()}
                              className="w-100 btn btn-primary btn-cadastrar"
                            >
                              {"Salvar"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <ModernAlertDialog
                      open={open}
                      handleClose={handleClose}
                      title={title}
                      msg={msg}
                    />
                  </div>

                  <div>
                    <Dialog
                      open={openDialog}
                      keepMounted
                      onClose={handleCloseDialog}
                      aria-describedby="alert-dialog-slide-description"
                    >
                      <DialogTitle>{title}</DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                          {msg}
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleCloseDialog}>Cancelar</Button>
                        <Button onClick={handleClickDialog}>OK</Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </div>
              </Box>
            }
          />
        ) : (
          <Navigate to="/login" />
        )}
      </>
    </div>
  );
}

export default Freight;
